// @generated by protobuf-ts 2.2.3-alpha.1 with parameter server_none,generate_dependencies
// @generated from protobuf file "prapi.proto" (package "pr.v3", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "./google/protobuf/timestamp";
/**
 * @generated from protobuf message pr.v3.Roles
 */
export interface Roles {
    /**
     * @generated from protobuf field: repeated pr.v3.Role roles = 1;
     */
    roles: Role[];
}
/**
 * @generated from protobuf message pr.v3.OrderHistoryReq
 */
export interface OrderHistoryReq {
}
/**
 * @generated from protobuf message pr.v3.OrderHistoryResp
 */
export interface OrderHistoryResp {
    /**
     * @generated from protobuf field: repeated pr.v3.OrderHistoryResp.Order orders = 1;
     */
    orders: OrderHistoryResp_Order[];
}
/**
 * @generated from protobuf message pr.v3.OrderHistoryResp.Order
 */
export interface OrderHistoryResp_Order {
    /**
     * @generated from protobuf field: int64 id = 1;
     */
    id: bigint;
    /**
     * @generated from protobuf field: string number = 2;
     */
    number: string;
    /**
     * @generated from protobuf field: string type = 3;
     */
    type: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp finish_date = 4;
     */
    finishDate?: Timestamp;
    /**
     * @generated from protobuf field: string lesson = 5;
     */
    lesson: string;
}
/**
 * @generated from protobuf message pr.v3.OrderReq
 */
export interface OrderReq {
    /**
     * @generated from protobuf field: int64 id = 1;
     */
    id: bigint;
}
/**
 * @generated from protobuf message pr.v3.OrderResp
 */
export interface OrderResp {
    /**
     * @generated from protobuf field: string number = 1;
     */
    number: string;
    /**
     * @generated from protobuf field: string type = 2;
     */
    type: string;
    /**
     * @generated from protobuf field: string lesson = 3;
     */
    lesson: string;
    /**
     * @generated from protobuf field: string theme = 4;
     */
    theme: string;
    /**
     * @generated from protobuf field: string size = 5;
     */
    size: string;
    /**
     * @generated from protobuf field: string demand = 6;
     */
    demand: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp finish_date = 7;
     */
    finishDate?: Timestamp;
    /**
     * @generated from protobuf field: float price = 8;
     */
    price: number;
    /**
     * @generated from protobuf field: repeated pr.v3.File order_files = 9;
     */
    orderFiles: File[];
    /**
     * @generated from protobuf field: repeated pr.v3.File work_files = 10;
     */
    workFiles: File[];
}
/**
 * @generated from protobuf message pr.v3.File
 */
export interface File {
    /**
     * @generated from protobuf field: int64 id = 1;
     */
    id: bigint;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: string guid = 3;
     */
    guid: string;
    /**
     * @generated from protobuf field: string secret = 4;
     */
    secret: string;
}
/**
 * @generated from protobuf message pr.v3.XvOrdersReq
 */
export interface XvOrdersReq {
    /**
     * @generated from protobuf field: pr.v3.XvOrdersReq.OrderType type = 1;
     */
    type: XvOrdersReq_OrderType;
}
/**
 * @generated from protobuf enum pr.v3.XvOrdersReq.OrderType
 */
export enum XvOrdersReq_OrderType {
    /**
     * @generated from protobuf enum value: ORDER_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ORDER_TYPE_CURRENT = 1;
     */
    CURRENT = 1
}
/**
 * @generated from protobuf message pr.v3.XvOrdersResp
 */
export interface XvOrdersResp {
    /**
     * @generated from protobuf field: repeated pr.v3.XvOrdersResp.Order orders = 1;
     */
    orders: XvOrdersResp_Order[];
}
/**
 * @generated from protobuf message pr.v3.XvOrdersResp.User
 */
export interface XvOrdersResp_User {
    /**
     * @generated from protobuf field: int64 id = 1;
     */
    id: bigint;
    /**
     * @generated from protobuf field: string email = 2;
     */
    email: string;
    /**
     * @generated from protobuf field: string name = 3;
     */
    name: string;
    /**
     * @generated from protobuf field: string phone = 4;
     */
    phone: string;
    /**
     * @generated from protobuf field: int64 orders_payed = 5;
     */
    ordersPayed: bigint;
    /**
     * @generated from protobuf field: int64 orders_not_payed = 6;
     */
    ordersNotPayed: bigint;
    /**
     * @generated from protobuf field: int64 orders_summary = 7;
     */
    ordersSummary: bigint;
}
/**
 * @generated from protobuf message pr.v3.XvOrdersResp.Order
 */
export interface XvOrdersResp_Order {
    /**
     * @generated from protobuf field: int64 id = 1;
     */
    id: bigint;
    /**
     * @generated from protobuf field: int64 season_id = 2;
     */
    seasonId: bigint;
    /**
     * @generated from protobuf field: string type = 3;
     */
    type: string;
    /**
     * @generated from protobuf field: string lesson = 4;
     */
    lesson: string;
    /**
     * @generated from protobuf field: string theme = 5;
     */
    theme: string;
    /**
     * @generated from protobuf field: string size = 6;
     */
    size: string;
    /**
     * @generated from protobuf field: string demand = 7;
     */
    demand: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp finish_date = 8;
     */
    finishDate?: Timestamp;
    /**
     * @generated from protobuf field: float price = 9;
     */
    price: number;
    /**
     * @generated from protobuf field: float prepayment = 10;
     */
    prepayment: number;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp publish_date = 11;
     */
    publishDate?: Timestamp;
    /**
     * @generated from protobuf field: string comment = 12;
     */
    comment: string;
    /**
     * @generated from protobuf field: pr.v3.InternalStatus internal_status = 13;
     */
    internalStatus: InternalStatus;
    /**
     * @generated from protobuf field: float discount = 14;
     */
    discount: number;
    /**
     * @generated from protobuf field: pr.v3.XvOrdersResp.User user = 15;
     */
    user?: XvOrdersResp_User;
    /**
     * @generated from protobuf field: repeated pr.v3.File order_files = 16;
     */
    orderFiles: File[];
    /**
     * @generated from protobuf field: repeated pr.v3.File work_files = 17;
     */
    workFiles: File[];
    /**
     * @generated from protobuf field: bool view_mail_price = 18;
     */
    viewMailPrice: boolean;
    /**
     * @generated from protobuf field: bool view_site_price = 19;
     */
    viewSitePrice: boolean;
    /**
     * @generated from protobuf field: bool view_mail_pay = 20;
     */
    viewMailPay: boolean;
    /**
     * @generated from protobuf field: bool view_site_pay = 21;
     */
    viewSitePay: boolean;
}
/**
 * @generated from protobuf message pr.v3.XvSetOrderStatusReq
 */
export interface XvSetOrderStatusReq {
    /**
     * @generated from protobuf field: int64 id = 1;
     */
    id: bigint;
    /**
     * @generated from protobuf field: pr.v3.InternalStatus status = 2;
     */
    status: InternalStatus;
    /**
     * @generated from protobuf field: optional float price = 3;
     */
    price?: number;
    /**
     * @generated from protobuf field: optional bool send_mail_on_cancel = 4;
     */
    sendMailOnCancel?: boolean;
}
/**
 * @generated from protobuf message pr.v3.XvSetOrderStatusResp
 */
export interface XvSetOrderStatusResp {
}
/**
 * @generated from protobuf message pr.v3.OrderToCheckReq
 */
export interface OrderToCheckReq {
    /**
     * @generated from protobuf field: int64 id = 1;
     */
    id: bigint;
    /**
     * @generated from protobuf field: repeated int64 file_ids = 2;
     */
    fileIds: bigint[];
}
/**
 * @generated from protobuf message pr.v3.OrderToCheckResp
 */
export interface OrderToCheckResp {
}
/**
 * @generated from protobuf message pr.v3.OrdersReq
 */
export interface OrdersReq {
}
/**
 * @generated from protobuf message pr.v3.OrdersResp
 */
export interface OrdersResp {
    /**
     * @generated from protobuf field: repeated pr.v3.OrdersResp.Order orders = 1;
     */
    orders: OrdersResp_Order[];
}
/**
 * @generated from protobuf message pr.v3.OrdersResp.User
 */
export interface OrdersResp_User {
    /**
     * @generated from protobuf field: int64 id = 1;
     */
    id: bigint;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
}
/**
 * @generated from protobuf message pr.v3.OrdersResp.SettedPrice
 */
export interface OrdersResp_SettedPrice {
    /**
     * @generated from protobuf field: pr.v3.OrdersResp.User user = 1;
     */
    user?: OrdersResp_User;
    /**
     * @generated from protobuf field: float price = 2;
     */
    price: number;
}
/**
 * @generated from protobuf message pr.v3.OrdersResp.Order
 */
export interface OrdersResp_Order {
    /**
     * @generated from protobuf field: int64 id = 1;
     */
    id: bigint;
    /**
     * @generated from protobuf field: string number = 2;
     */
    number: string;
    /**
     * @generated from protobuf field: string type = 3;
     */
    type: string;
    /**
     * @generated from protobuf field: string lesson = 4;
     */
    lesson: string;
    /**
     * @generated from protobuf field: string theme = 5;
     */
    theme: string;
    /**
     * @generated from protobuf field: string size = 6;
     */
    size: string;
    /**
     * @generated from protobuf field: string demand = 7;
     */
    demand: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp finish_date = 8;
     */
    finishDate?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp publish_date = 9;
     */
    publishDate?: Timestamp;
    /**
     * @generated from protobuf field: float price = 10;
     */
    price: number;
    /**
     * @generated from protobuf field: repeated pr.v3.File order_files = 11;
     */
    orderFiles: File[];
    /**
     * @generated from protobuf field: repeated pr.v3.File work_files = 12;
     */
    workFiles: File[];
    /**
     * @generated from protobuf field: pr.v3.OrdersResp.User user = 13;
     */
    user?: OrdersResp_User;
    /**
     * @generated from protobuf field: pr.v3.PrInternalStatus internal_status = 14;
     */
    internalStatus: PrInternalStatus;
    /**
     * @generated from protobuf field: repeated pr.v3.OrdersResp.SettedPrice setted_prices = 15;
     */
    settedPrices: OrdersResp_SettedPrice[];
    /**
     * @generated from protobuf field: repeated bool checks = 16;
     */
    checks: boolean[];
}
/**
 * @generated from protobuf message pr.v3.DeleteFileReq
 */
export interface DeleteFileReq {
    /**
     * @generated from protobuf field: int64 id = 1;
     */
    id: bigint;
    /**
     * @generated from protobuf field: int64 order_id = 2;
     */
    orderId: bigint;
    /**
     * @generated from protobuf field: pr.v3.DeleteFileReq.FileType type = 3;
     */
    type: DeleteFileReq_FileType;
}
/**
 * @generated from protobuf enum pr.v3.DeleteFileReq.FileType
 */
export enum DeleteFileReq_FileType {
    /**
     * @generated from protobuf enum value: FILE_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: FILE_TYPE_ORDER = 1;
     */
    ORDER = 1,
    /**
     * @generated from protobuf enum value: FILE_TYPE_WORK = 2;
     */
    WORK = 2
}
/**
 * @generated from protobuf message pr.v3.DeleteFileResp
 */
export interface DeleteFileResp {
}
/**
 * @generated from protobuf message pr.v3.AddMoneyReq
 */
export interface AddMoneyReq {
    /**
     * @generated from protobuf field: pr.v3.AddMoneyReq.Type type = 1;
     */
    type: AddMoneyReq_Type;
    /**
     * @generated from protobuf field: float amount = 2;
     */
    amount: number;
    /**
     * @generated from protobuf field: string comment = 3;
     */
    comment: string;
}
/**
 * @generated from protobuf enum pr.v3.AddMoneyReq.Type
 */
export enum AddMoneyReq_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: TYPE_CARDS = 1;
     */
    CARDS = 1,
    /**
     * @generated from protobuf enum value: TYPE_CASH_ON_HANDS_ANDREY = 2;
     */
    CASH_ON_HANDS_ANDREY = 2,
    /**
     * @generated from protobuf enum value: TYPE_CASH_ON_HANDS_SVETA = 3;
     */
    CASH_ON_HANDS_SVETA = 3
}
/**
 * @generated from protobuf message pr.v3.AddMoneyResp
 */
export interface AddMoneyResp {
}
/**
 * @generated from protobuf message pr.v3.OrderToAdmReq
 */
export interface OrderToAdmReq {
    /**
     * @generated from protobuf field: int64 id = 1;
     */
    id: bigint;
}
/**
 * @generated from protobuf message pr.v3.OrderToAdmResp
 */
export interface OrderToAdmResp {
    /**
     * @generated from protobuf field: pr.v3.OrderToAdmResp.Order order = 1;
     */
    order?: OrderToAdmResp_Order;
}
/**
 * @generated from protobuf message pr.v3.OrderToAdmResp.Order
 */
export interface OrderToAdmResp_Order {
    /**
     * @generated from protobuf field: string number = 1;
     */
    number: string;
    /**
     * @generated from protobuf field: string type = 2;
     */
    type: string;
    /**
     * @generated from protobuf field: string lesson = 3;
     */
    lesson: string;
    /**
     * @generated from protobuf field: string theme = 4;
     */
    theme: string;
    /**
     * @generated from protobuf field: string demand = 5;
     */
    demand: string;
    /**
     * @generated from protobuf field: string size = 6;
     */
    size: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp finish_date = 7;
     */
    finishDate?: Timestamp;
    /**
     * @generated from protobuf field: float price = 8;
     */
    price: number;
    /**
     * @generated from protobuf field: int64 user_id = 9;
     */
    userId: bigint;
    /**
     * @generated from protobuf field: bool economics = 10;
     */
    economics: boolean;
    /**
     * @generated from protobuf field: bool humanitary = 11;
     */
    humanitary: boolean;
    /**
     * @generated from protobuf field: bool juridas = 12;
     */
    juridas: boolean;
    /**
     * @generated from protobuf field: bool languages = 13;
     */
    languages: boolean;
    /**
     * @generated from protobuf field: bool technology = 14;
     */
    technology: boolean;
    /**
     * @generated from protobuf field: repeated pr.v3.File order_files = 15;
     */
    orderFiles: File[];
    /**
     * @generated from protobuf field: repeated pr.v3.File work_files = 16;
     */
    workFiles: File[];
    /**
     * @generated from protobuf field: bool deleted = 17;
     */
    deleted: boolean;
}
/**
 * @generated from protobuf message pr.v3.UpdateOrderReq
 */
export interface UpdateOrderReq {
    /**
     * @generated from protobuf field: int64 id = 1;
     */
    id: bigint;
    /**
     * @generated from protobuf field: pr.v3.UpdateOrderReq.Order order = 2;
     */
    order?: UpdateOrderReq_Order;
}
/**
 * @generated from protobuf message pr.v3.UpdateOrderReq.Order
 */
export interface UpdateOrderReq_Order {
    /**
     * @generated from protobuf field: string number = 1;
     */
    number: string;
    /**
     * @generated from protobuf field: string type = 2;
     */
    type: string;
    /**
     * @generated from protobuf field: string lesson = 3;
     */
    lesson: string;
    /**
     * @generated from protobuf field: string theme = 4;
     */
    theme: string;
    /**
     * @generated from protobuf field: string demand = 5;
     */
    demand: string;
    /**
     * @generated from protobuf field: string size = 6;
     */
    size: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp finish_date = 7;
     */
    finishDate?: Timestamp;
    /**
     * @generated from protobuf field: float price = 8;
     */
    price: number;
    /**
     * @generated from protobuf field: int64 user_id = 9;
     */
    userId: bigint;
    /**
     * @generated from protobuf field: bool economics = 10;
     */
    economics: boolean;
    /**
     * @generated from protobuf field: bool humanitary = 11;
     */
    humanitary: boolean;
    /**
     * @generated from protobuf field: bool juridas = 12;
     */
    juridas: boolean;
    /**
     * @generated from protobuf field: bool languages = 13;
     */
    languages: boolean;
    /**
     * @generated from protobuf field: bool technology = 14;
     */
    technology: boolean;
    /**
     * @generated from protobuf field: bool deleted = 15;
     */
    deleted: boolean;
    /**
     * @generated from protobuf field: repeated int64 order_files = 16;
     */
    orderFiles: bigint[];
}
/**
 * @generated from protobuf message pr.v3.UpdateOrderResp
 */
export interface UpdateOrderResp {
}
/**
 * @generated from protobuf message pr.v3.OrderPayedReq
 */
export interface OrderPayedReq {
    /**
     * @generated from protobuf field: repeated int64 ids = 1;
     */
    ids: bigint[];
    /**
     * @generated from protobuf field: string pay_comment = 2;
     */
    payComment: string;
}
/**
 * @generated from protobuf message pr.v3.OrderPayedResp
 */
export interface OrderPayedResp {
}
/**
 * @generated from protobuf message pr.v3.OrderAcceptPriceReq
 */
export interface OrderAcceptPriceReq {
    /**
     * @generated from protobuf field: int64 id = 1;
     */
    id: bigint;
    /**
     * @generated from protobuf field: int64 user_id = 2;
     */
    userId: bigint;
    /**
     * @generated from protobuf field: float price = 3;
     */
    price: number;
}
/**
 * @generated from protobuf message pr.v3.OrderAcceptPriceResp
 */
export interface OrderAcceptPriceResp {
}
/**
 * @generated from protobuf message pr.v3.XvOrdersHistoryReq
 */
export interface XvOrdersHistoryReq {
}
/**
 * @generated from protobuf message pr.v3.XvOrdersHistoryResp
 */
export interface XvOrdersHistoryResp {
    /**
     * @generated from protobuf field: repeated pr.v3.XvOrdersHistoryResp.Order orders = 1;
     */
    orders: XvOrdersHistoryResp_Order[];
}
/**
 * @generated from protobuf message pr.v3.XvOrdersHistoryResp.Order
 */
export interface XvOrdersHistoryResp_Order {
    /**
     * @generated from protobuf field: int64 id = 1;
     */
    id: bigint;
    /**
     * @generated from protobuf field: int64 season_id = 2;
     */
    seasonId: bigint;
    /**
     * @generated from protobuf field: string type = 3;
     */
    type: string;
    /**
     * @generated from protobuf field: string lesson = 4;
     */
    lesson: string;
    /**
     * @generated from protobuf field: pr.v3.InternalStatus internal_status = 13;
     */
    internalStatus: InternalStatus;
}
/**
 * @generated from protobuf message pr.v3.XvOrderReq
 */
export interface XvOrderReq {
    /**
     * @generated from protobuf field: int64 id = 1;
     */
    id: bigint;
}
/**
 * @generated from protobuf message pr.v3.XvOrderResp
 */
export interface XvOrderResp {
    /**
     * @generated from protobuf field: pr.v3.XvOrderResp.Order order = 1;
     */
    order?: XvOrderResp_Order;
}
/**
 * @generated from protobuf message pr.v3.XvOrderResp.Order
 */
export interface XvOrderResp_Order {
    /**
     * @generated from protobuf field: int64 season_id = 1;
     */
    seasonId: bigint;
    /**
     * @generated from protobuf field: string type = 2;
     */
    type: string;
    /**
     * @generated from protobuf field: string lesson = 3;
     */
    lesson: string;
    /**
     * @generated from protobuf field: string theme = 4;
     */
    theme: string;
    /**
     * @generated from protobuf field: string size = 5;
     */
    size: string;
    /**
     * @generated from protobuf field: string demand = 6;
     */
    demand: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp finish_date = 7;
     */
    finishDate?: Timestamp;
    /**
     * @generated from protobuf field: float price = 8;
     */
    price: number;
    /**
     * @generated from protobuf field: float prepayment = 9;
     */
    prepayment: number;
    /**
     * @generated from protobuf field: string comment = 10;
     */
    comment: string;
    /**
     * @generated from protobuf field: float discount = 11;
     */
    discount: number;
    /**
     * @generated from protobuf field: repeated pr.v3.File order_files = 12;
     */
    orderFiles: File[];
    /**
     * @generated from protobuf field: repeated pr.v3.File work_files = 13;
     */
    workFiles: File[];
}
/**
 * @generated from protobuf message pr.v3.XvUpdateOrderReq
 */
export interface XvUpdateOrderReq {
    /**
     * @generated from protobuf field: int64 id = 1;
     */
    id: bigint;
    /**
     * @generated from protobuf field: pr.v3.XvUpdateOrderReq.Order order = 2;
     */
    order?: XvUpdateOrderReq_Order;
}
/**
 * @generated from protobuf message pr.v3.XvUpdateOrderReq.Order
 */
export interface XvUpdateOrderReq_Order {
    /**
     * @generated from protobuf field: int64 season_id = 1;
     */
    seasonId: bigint;
    /**
     * @generated from protobuf field: string type = 2;
     */
    type: string;
    /**
     * @generated from protobuf field: string lesson = 3;
     */
    lesson: string;
    /**
     * @generated from protobuf field: string theme = 4;
     */
    theme: string;
    /**
     * @generated from protobuf field: string size = 5;
     */
    size: string;
    /**
     * @generated from protobuf field: string demand = 6;
     */
    demand: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp finish_date = 7;
     */
    finishDate?: Timestamp;
    /**
     * @generated from protobuf field: float price = 8;
     */
    price: number;
    /**
     * @generated from protobuf field: float prepayment = 9;
     */
    prepayment: number;
    /**
     * @generated from protobuf field: string comment = 10;
     */
    comment: string;
    /**
     * @generated from protobuf field: float discount = 11;
     */
    discount: number;
    /**
     * @generated from protobuf field: repeated int64 work_files = 12;
     */
    workFiles: bigint[];
}
/**
 * @generated from protobuf message pr.v3.XvUpdateOrderResp
 */
export interface XvUpdateOrderResp {
}
/**
 * @generated from protobuf message pr.v3.XvDeleteFileReq
 */
export interface XvDeleteFileReq {
    /**
     * @generated from protobuf field: int64 id = 1;
     */
    id: bigint;
    /**
     * @generated from protobuf field: int64 order_id = 2;
     */
    orderId: bigint;
    /**
     * @generated from protobuf field: pr.v3.XvDeleteFileReq.FileType type = 3;
     */
    type: XvDeleteFileReq_FileType;
}
/**
 * @generated from protobuf enum pr.v3.XvDeleteFileReq.FileType
 */
export enum XvDeleteFileReq_FileType {
    /**
     * @generated from protobuf enum value: FILE_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: FILE_TYPE_ORDER = 1;
     */
    ORDER = 1,
    /**
     * @generated from protobuf enum value: FILE_TYPE_WORK = 2;
     */
    WORK = 2
}
/**
 * @generated from protobuf message pr.v3.XvDeleteFileResp
 */
export interface XvDeleteFileResp {
}
/**
 * @generated from protobuf message pr.v3.UsersReq
 */
export interface UsersReq {
}
/**
 * @generated from protobuf message pr.v3.UsersResp
 */
export interface UsersResp {
    /**
     * @generated from protobuf field: repeated pr.v3.UsersResp.User users = 1;
     */
    users: UsersResp_User[];
}
/**
 * @generated from protobuf message pr.v3.UsersResp.User
 */
export interface UsersResp_User {
    /**
     * @generated from protobuf field: int64 id = 1;
     */
    id: bigint;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_visit = 3;
     */
    lastVisit?: Timestamp;
    /**
     * @generated from protobuf field: bool email_notify = 4;
     */
    emailNotify: boolean;
}
/**
 * @generated from protobuf message pr.v3.XvAddFilesReq
 */
export interface XvAddFilesReq {
    /**
     * @generated from protobuf field: repeated int64 ids = 1;
     */
    ids: bigint[];
    /**
     * @generated from protobuf field: int64 order_id = 2;
     */
    orderId: bigint;
    /**
     * @generated from protobuf field: pr.v3.XvAddFilesReq.FileType type = 3;
     */
    type: XvAddFilesReq_FileType;
}
/**
 * @generated from protobuf enum pr.v3.XvAddFilesReq.FileType
 */
export enum XvAddFilesReq_FileType {
    /**
     * @generated from protobuf enum value: FILE_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: FILE_TYPE_ORDER = 1;
     */
    ORDER = 1,
    /**
     * @generated from protobuf enum value: FILE_TYPE_WORK = 2;
     */
    WORK = 2
}
/**
 * @generated from protobuf message pr.v3.XvAddFilesResp
 */
export interface XvAddFilesResp {
}
/**
 * @generated from protobuf message pr.v3.OrderHistoryToAdminReq
 */
export interface OrderHistoryToAdminReq {
}
/**
 * @generated from protobuf message pr.v3.OrderHistoryToAdminResp
 */
export interface OrderHistoryToAdminResp {
    /**
     * @generated from protobuf field: repeated pr.v3.OrderHistoryToAdminResp.Order orders = 1;
     */
    orders: OrderHistoryToAdminResp_Order[];
}
/**
 * @generated from protobuf message pr.v3.OrderHistoryToAdminResp.Order
 */
export interface OrderHistoryToAdminResp_Order {
    /**
     * @generated from protobuf field: int64 id = 1;
     */
    id: bigint;
    /**
     * @generated from protobuf field: string number = 2;
     */
    number: string;
    /**
     * @generated from protobuf field: string type = 3;
     */
    type: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp finish_date = 4;
     */
    finishDate?: Timestamp;
    /**
     * @generated from protobuf field: string lesson = 5;
     */
    lesson: string;
    /**
     * @generated from protobuf field: int64 user_id = 6;
     */
    userId: bigint;
}
/**
 * @generated from protobuf message pr.v3.XvUserOrdersReq
 */
export interface XvUserOrdersReq {
    /**
     * @generated from protobuf field: int64 user_id = 1;
     */
    userId: bigint;
}
/**
 * @generated from protobuf message pr.v3.XvUserOrdersResp
 */
export interface XvUserOrdersResp {
    /**
     * @generated from protobuf field: repeated pr.v3.XvUserOrdersResp.Order orders = 1;
     */
    orders: XvUserOrdersResp_Order[];
}
/**
 * @generated from protobuf message pr.v3.XvUserOrdersResp.Order
 */
export interface XvUserOrdersResp_Order {
    /**
     * @generated from protobuf field: int64 id = 1;
     */
    id: bigint;
    /**
     * @generated from protobuf field: int64 season_id = 2;
     */
    seasonId: bigint;
    /**
     * @generated from protobuf field: string type = 3;
     */
    type: string;
    /**
     * @generated from protobuf field: string lesson = 4;
     */
    lesson: string;
    /**
     * @generated from protobuf field: pr.v3.InternalStatus internal_status = 5;
     */
    internalStatus: InternalStatus;
    /**
     * @generated from protobuf field: float price = 6;
     */
    price: number;
}
/**
 * @generated from protobuf message pr.v3.UserReq
 */
export interface UserReq {
    /**
     * @generated from protobuf field: int64 id = 1;
     */
    id: bigint;
}
/**
 * @generated from protobuf message pr.v3.UserResp
 */
export interface UserResp {
    /**
     * @generated from protobuf field: string email = 1;
     */
    email: string;
    /**
     * @generated from protobuf field: float money = 2;
     */
    money: number;
    /**
     * @generated from protobuf field: string name = 3;
     */
    name: string;
    /**
     * @generated from protobuf field: int64 work = 4;
     */
    work: bigint;
    /**
     * @generated from protobuf field: string pay = 5;
     */
    pay: string;
    /**
     * @generated from protobuf field: string phone = 6;
     */
    phone: string;
    /**
     * @generated from protobuf field: bool email_notify = 7;
     */
    emailNotify: boolean;
    /**
     * @generated from protobuf field: bool economics = 8;
     */
    economics: boolean;
    /**
     * @generated from protobuf field: bool humanitary = 9;
     */
    humanitary: boolean;
    /**
     * @generated from protobuf field: bool juridas = 10;
     */
    juridas: boolean;
    /**
     * @generated from protobuf field: bool languages = 11;
     */
    languages: boolean;
    /**
     * @generated from protobuf field: bool technology = 12;
     */
    technology: boolean;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp register_date = 13;
     */
    registerDate?: Timestamp;
    /**
     * @generated from protobuf field: string notes = 14;
     */
    notes: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_visit = 15;
     */
    lastVisit?: Timestamp;
    /**
     * @generated from protobuf field: string ip = 16;
     */
    ip: string;
}
/**
 * @generated from protobuf message pr.v3.XvOrderPayNotifyReq
 */
export interface XvOrderPayNotifyReq {
    /**
     * @generated from protobuf field: int64 id = 1;
     */
    id: bigint;
}
/**
 * @generated from protobuf message pr.v3.XvOrderPayNotifyResp
 */
export interface XvOrderPayNotifyResp {
}
/**
 * @generated from protobuf message pr.v3.AuthRequest
 */
export interface AuthRequest {
    /**
     * @generated from protobuf field: string email = 1;
     */
    email: string;
    /**
     * @generated from protobuf field: string password = 2;
     */
    password: string;
}
/**
 * @generated from protobuf message pr.v3.AuthResponse
 */
export interface AuthResponse {
    /**
     * @generated from protobuf field: bool authorized = 1;
     */
    authorized: boolean;
}
/**
 * @generated from protobuf enum pr.v3.Role
 */
export enum Role {
    /**
     * @generated from protobuf enum value: ROLE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ROLE_ADMIN = 1;
     */
    ADMIN = 1,
    /**
     * @generated from protobuf enum value: ROLE_USER = 2;
     */
    USER = 2,
    /**
     * @generated from protobuf enum value: ROLE_INTERNAL = 3;
     */
    INTERNAL = 3,
    /**
     * @generated from protobuf enum value: ROLE_ANY = 4;
     */
    ANY = 4
}
/**
 * @generated from protobuf enum pr.v3.InternalStatus
 */
export enum InternalStatus {
    /**
     * @generated from protobuf enum value: INTERNAL_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: INTERNAL_STATUS_TO_SET_PRICE = 1;
     */
    TO_SET_PRICE = 1,
    /**
     * @generated from protobuf enum value: INTERNAL_STATUS_TO_CALL = 2;
     */
    TO_CALL = 2,
    /**
     * @generated from protobuf enum value: INTERNAL_STATUS_NO_ANSWER = 3;
     */
    NO_ANSWER = 3,
    /**
     * @generated from protobuf enum value: INTERNAL_STATUS_TO_PREPAY = 4;
     */
    TO_PREPAY = 4,
    /**
     * @generated from protobuf enum value: INTERNAL_STATUS_TO_WORK = 5;
     */
    TO_WORK = 5,
    /**
     * @generated from protobuf enum value: INTERNAL_STATUS_IN_WORK = 6;
     */
    IN_WORK = 6,
    /**
     * @generated from protobuf enum value: INTERNAL_STATUS_CANCELLED = 7;
     */
    CANCELLED = 7,
    /**
     * @generated from protobuf enum value: INTERNAL_STATUS_SUSPENDED = 8;
     */
    SUSPENDED = 8,
    /**
     * @generated from protobuf enum value: INTERNAL_STATUS_TO_PAY = 9;
     */
    TO_PAY = 9,
    /**
     * @generated from protobuf enum value: INTERNAL_STATUS_PAYED = 10;
     */
    PAYED = 10,
    /**
     * @generated from protobuf enum value: INTERNAL_STATUS_NOT_PAYED = 11;
     */
    NOT_PAYED = 11,
    /**
     * @generated from protobuf enum value: INTERNAL_STATUS_TO_ACCEPT = 12;
     */
    TO_ACCEPT = 12
}
/**
 * @generated from protobuf enum pr.v3.PrInternalStatus
 */
export enum PrInternalStatus {
    /**
     * @generated from protobuf enum value: PR_INTERNAL_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: PR_INTERNAL_STATUS_TO_WORK = 1;
     */
    TO_WORK = 1,
    /**
     * @generated from protobuf enum value: PR_INTERNAL_STATUS_IN_WORK = 2;
     */
    IN_WORK = 2,
    /**
     * @generated from protobuf enum value: PR_INTERNAL_STATUS_TO_CHECK = 3;
     */
    TO_CHECK = 3,
    /**
     * @generated from protobuf enum value: PR_INTERNAL_STATUS_TO_PAY = 4;
     */
    TO_PAY = 4,
    /**
     * @generated from protobuf enum value: PR_INTERNAL_STATUS_PAYED = 5;
     */
    PAYED = 5
}
// @generated message type with reflection information, may provide speed optimized methods
class Roles$Type extends MessageType<Roles> {
    constructor() {
        super("pr.v3.Roles", [
            { no: 1, name: "roles", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["pr.v3.Role", Role, "ROLE_"] }
        ]);
    }
    create(value?: PartialMessage<Roles>): Roles {
        const message = { roles: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Roles>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Roles): Roles {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated pr.v3.Role roles */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.roles.push(reader.int32());
                    else
                        message.roles.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Roles, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated pr.v3.Role roles = 1; */
        if (message.roles.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.roles.length; i++)
                writer.int32(message.roles[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.Roles
 */
export const Roles = new Roles$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrderHistoryReq$Type extends MessageType<OrderHistoryReq> {
    constructor() {
        super("pr.v3.OrderHistoryReq", []);
    }
    create(value?: PartialMessage<OrderHistoryReq>): OrderHistoryReq {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OrderHistoryReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrderHistoryReq): OrderHistoryReq {
        return target ?? this.create();
    }
    internalBinaryWrite(message: OrderHistoryReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.OrderHistoryReq
 */
export const OrderHistoryReq = new OrderHistoryReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrderHistoryResp$Type extends MessageType<OrderHistoryResp> {
    constructor() {
        super("pr.v3.OrderHistoryResp", [
            { no: 1, name: "orders", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => OrderHistoryResp_Order }
        ]);
    }
    create(value?: PartialMessage<OrderHistoryResp>): OrderHistoryResp {
        const message = { orders: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OrderHistoryResp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrderHistoryResp): OrderHistoryResp {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated pr.v3.OrderHistoryResp.Order orders */ 1:
                    message.orders.push(OrderHistoryResp_Order.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrderHistoryResp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated pr.v3.OrderHistoryResp.Order orders = 1; */
        for (let i = 0; i < message.orders.length; i++)
            OrderHistoryResp_Order.internalBinaryWrite(message.orders[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.OrderHistoryResp
 */
export const OrderHistoryResp = new OrderHistoryResp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrderHistoryResp_Order$Type extends MessageType<OrderHistoryResp_Order> {
    constructor() {
        super("pr.v3.OrderHistoryResp.Order", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "finish_date", kind: "message", T: () => Timestamp },
            { no: 5, name: "lesson", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OrderHistoryResp_Order>): OrderHistoryResp_Order {
        const message = { id: 0n, number: "", type: "", lesson: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OrderHistoryResp_Order>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrderHistoryResp_Order): OrderHistoryResp_Order {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* string number */ 2:
                    message.number = reader.string();
                    break;
                case /* string type */ 3:
                    message.type = reader.string();
                    break;
                case /* google.protobuf.Timestamp finish_date */ 4:
                    message.finishDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.finishDate);
                    break;
                case /* string lesson */ 5:
                    message.lesson = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrderHistoryResp_Order, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* string number = 2; */
        if (message.number !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.number);
        /* string type = 3; */
        if (message.type !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.type);
        /* google.protobuf.Timestamp finish_date = 4; */
        if (message.finishDate)
            Timestamp.internalBinaryWrite(message.finishDate, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string lesson = 5; */
        if (message.lesson !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.lesson);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.OrderHistoryResp.Order
 */
export const OrderHistoryResp_Order = new OrderHistoryResp_Order$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrderReq$Type extends MessageType<OrderReq> {
    constructor() {
        super("pr.v3.OrderReq", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<OrderReq>): OrderReq {
        const message = { id: 0n };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OrderReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrderReq): OrderReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrderReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.OrderReq
 */
export const OrderReq = new OrderReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrderResp$Type extends MessageType<OrderResp> {
    constructor() {
        super("pr.v3.OrderResp", [
            { no: 1, name: "number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "lesson", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "theme", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "size", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "demand", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "finish_date", kind: "message", T: () => Timestamp },
            { no: 8, name: "price", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 9, name: "order_files", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => File },
            { no: 10, name: "work_files", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => File }
        ]);
    }
    create(value?: PartialMessage<OrderResp>): OrderResp {
        const message = { number: "", type: "", lesson: "", theme: "", size: "", demand: "", price: 0, orderFiles: [], workFiles: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OrderResp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrderResp): OrderResp {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string number */ 1:
                    message.number = reader.string();
                    break;
                case /* string type */ 2:
                    message.type = reader.string();
                    break;
                case /* string lesson */ 3:
                    message.lesson = reader.string();
                    break;
                case /* string theme */ 4:
                    message.theme = reader.string();
                    break;
                case /* string size */ 5:
                    message.size = reader.string();
                    break;
                case /* string demand */ 6:
                    message.demand = reader.string();
                    break;
                case /* google.protobuf.Timestamp finish_date */ 7:
                    message.finishDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.finishDate);
                    break;
                case /* float price */ 8:
                    message.price = reader.float();
                    break;
                case /* repeated pr.v3.File order_files */ 9:
                    message.orderFiles.push(File.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated pr.v3.File work_files */ 10:
                    message.workFiles.push(File.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrderResp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string number = 1; */
        if (message.number !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.number);
        /* string type = 2; */
        if (message.type !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.type);
        /* string lesson = 3; */
        if (message.lesson !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.lesson);
        /* string theme = 4; */
        if (message.theme !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.theme);
        /* string size = 5; */
        if (message.size !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.size);
        /* string demand = 6; */
        if (message.demand !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.demand);
        /* google.protobuf.Timestamp finish_date = 7; */
        if (message.finishDate)
            Timestamp.internalBinaryWrite(message.finishDate, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* float price = 8; */
        if (message.price !== 0)
            writer.tag(8, WireType.Bit32).float(message.price);
        /* repeated pr.v3.File order_files = 9; */
        for (let i = 0; i < message.orderFiles.length; i++)
            File.internalBinaryWrite(message.orderFiles[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated pr.v3.File work_files = 10; */
        for (let i = 0; i < message.workFiles.length; i++)
            File.internalBinaryWrite(message.workFiles[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.OrderResp
 */
export const OrderResp = new OrderResp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class File$Type extends MessageType<File> {
    constructor() {
        super("pr.v3.File", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "guid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "secret", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<File>): File {
        const message = { id: 0n, name: "", guid: "", secret: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<File>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: File): File {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string guid */ 3:
                    message.guid = reader.string();
                    break;
                case /* string secret */ 4:
                    message.secret = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: File, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string guid = 3; */
        if (message.guid !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.guid);
        /* string secret = 4; */
        if (message.secret !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.secret);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.File
 */
export const File = new File$Type();
// @generated message type with reflection information, may provide speed optimized methods
class XvOrdersReq$Type extends MessageType<XvOrdersReq> {
    constructor() {
        super("pr.v3.XvOrdersReq", [
            { no: 1, name: "type", kind: "enum", T: () => ["pr.v3.XvOrdersReq.OrderType", XvOrdersReq_OrderType, "ORDER_TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<XvOrdersReq>): XvOrdersReq {
        const message = { type: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<XvOrdersReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: XvOrdersReq): XvOrdersReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* pr.v3.XvOrdersReq.OrderType type */ 1:
                    message.type = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: XvOrdersReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* pr.v3.XvOrdersReq.OrderType type = 1; */
        if (message.type !== 0)
            writer.tag(1, WireType.Varint).int32(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.XvOrdersReq
 */
export const XvOrdersReq = new XvOrdersReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class XvOrdersResp$Type extends MessageType<XvOrdersResp> {
    constructor() {
        super("pr.v3.XvOrdersResp", [
            { no: 1, name: "orders", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => XvOrdersResp_Order }
        ]);
    }
    create(value?: PartialMessage<XvOrdersResp>): XvOrdersResp {
        const message = { orders: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<XvOrdersResp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: XvOrdersResp): XvOrdersResp {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated pr.v3.XvOrdersResp.Order orders */ 1:
                    message.orders.push(XvOrdersResp_Order.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: XvOrdersResp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated pr.v3.XvOrdersResp.Order orders = 1; */
        for (let i = 0; i < message.orders.length; i++)
            XvOrdersResp_Order.internalBinaryWrite(message.orders[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.XvOrdersResp
 */
export const XvOrdersResp = new XvOrdersResp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class XvOrdersResp_User$Type extends MessageType<XvOrdersResp_User> {
    constructor() {
        super("pr.v3.XvOrdersResp.User", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "phone", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "orders_payed", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 6, name: "orders_not_payed", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 7, name: "orders_summary", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<XvOrdersResp_User>): XvOrdersResp_User {
        const message = { id: 0n, email: "", name: "", phone: "", ordersPayed: 0n, ordersNotPayed: 0n, ordersSummary: 0n };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<XvOrdersResp_User>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: XvOrdersResp_User): XvOrdersResp_User {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* string email */ 2:
                    message.email = reader.string();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* string phone */ 4:
                    message.phone = reader.string();
                    break;
                case /* int64 orders_payed */ 5:
                    message.ordersPayed = reader.int64().toBigInt();
                    break;
                case /* int64 orders_not_payed */ 6:
                    message.ordersNotPayed = reader.int64().toBigInt();
                    break;
                case /* int64 orders_summary */ 7:
                    message.ordersSummary = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: XvOrdersResp_User, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* string email = 2; */
        if (message.email !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.email);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* string phone = 4; */
        if (message.phone !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.phone);
        /* int64 orders_payed = 5; */
        if (message.ordersPayed !== 0n)
            writer.tag(5, WireType.Varint).int64(message.ordersPayed);
        /* int64 orders_not_payed = 6; */
        if (message.ordersNotPayed !== 0n)
            writer.tag(6, WireType.Varint).int64(message.ordersNotPayed);
        /* int64 orders_summary = 7; */
        if (message.ordersSummary !== 0n)
            writer.tag(7, WireType.Varint).int64(message.ordersSummary);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.XvOrdersResp.User
 */
export const XvOrdersResp_User = new XvOrdersResp_User$Type();
// @generated message type with reflection information, may provide speed optimized methods
class XvOrdersResp_Order$Type extends MessageType<XvOrdersResp_Order> {
    constructor() {
        super("pr.v3.XvOrdersResp.Order", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "season_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "lesson", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "theme", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "size", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "demand", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "finish_date", kind: "message", T: () => Timestamp },
            { no: 9, name: "price", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 10, name: "prepayment", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 11, name: "publish_date", kind: "message", T: () => Timestamp },
            { no: 12, name: "comment", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "internal_status", kind: "enum", T: () => ["pr.v3.InternalStatus", InternalStatus, "INTERNAL_STATUS_"] },
            { no: 14, name: "discount", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 15, name: "user", kind: "message", T: () => XvOrdersResp_User },
            { no: 16, name: "order_files", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => File },
            { no: 17, name: "work_files", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => File },
            { no: 18, name: "view_mail_price", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 19, name: "view_site_price", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 20, name: "view_mail_pay", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 21, name: "view_site_pay", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<XvOrdersResp_Order>): XvOrdersResp_Order {
        const message = { id: 0n, seasonId: 0n, type: "", lesson: "", theme: "", size: "", demand: "", price: 0, prepayment: 0, comment: "", internalStatus: 0, discount: 0, orderFiles: [], workFiles: [], viewMailPrice: false, viewSitePrice: false, viewMailPay: false, viewSitePay: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<XvOrdersResp_Order>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: XvOrdersResp_Order): XvOrdersResp_Order {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* int64 season_id */ 2:
                    message.seasonId = reader.int64().toBigInt();
                    break;
                case /* string type */ 3:
                    message.type = reader.string();
                    break;
                case /* string lesson */ 4:
                    message.lesson = reader.string();
                    break;
                case /* string theme */ 5:
                    message.theme = reader.string();
                    break;
                case /* string size */ 6:
                    message.size = reader.string();
                    break;
                case /* string demand */ 7:
                    message.demand = reader.string();
                    break;
                case /* google.protobuf.Timestamp finish_date */ 8:
                    message.finishDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.finishDate);
                    break;
                case /* float price */ 9:
                    message.price = reader.float();
                    break;
                case /* float prepayment */ 10:
                    message.prepayment = reader.float();
                    break;
                case /* google.protobuf.Timestamp publish_date */ 11:
                    message.publishDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.publishDate);
                    break;
                case /* string comment */ 12:
                    message.comment = reader.string();
                    break;
                case /* pr.v3.InternalStatus internal_status */ 13:
                    message.internalStatus = reader.int32();
                    break;
                case /* float discount */ 14:
                    message.discount = reader.float();
                    break;
                case /* pr.v3.XvOrdersResp.User user */ 15:
                    message.user = XvOrdersResp_User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                case /* repeated pr.v3.File order_files */ 16:
                    message.orderFiles.push(File.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated pr.v3.File work_files */ 17:
                    message.workFiles.push(File.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool view_mail_price */ 18:
                    message.viewMailPrice = reader.bool();
                    break;
                case /* bool view_site_price */ 19:
                    message.viewSitePrice = reader.bool();
                    break;
                case /* bool view_mail_pay */ 20:
                    message.viewMailPay = reader.bool();
                    break;
                case /* bool view_site_pay */ 21:
                    message.viewSitePay = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: XvOrdersResp_Order, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* int64 season_id = 2; */
        if (message.seasonId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.seasonId);
        /* string type = 3; */
        if (message.type !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.type);
        /* string lesson = 4; */
        if (message.lesson !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.lesson);
        /* string theme = 5; */
        if (message.theme !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.theme);
        /* string size = 6; */
        if (message.size !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.size);
        /* string demand = 7; */
        if (message.demand !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.demand);
        /* google.protobuf.Timestamp finish_date = 8; */
        if (message.finishDate)
            Timestamp.internalBinaryWrite(message.finishDate, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* float price = 9; */
        if (message.price !== 0)
            writer.tag(9, WireType.Bit32).float(message.price);
        /* float prepayment = 10; */
        if (message.prepayment !== 0)
            writer.tag(10, WireType.Bit32).float(message.prepayment);
        /* google.protobuf.Timestamp publish_date = 11; */
        if (message.publishDate)
            Timestamp.internalBinaryWrite(message.publishDate, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* string comment = 12; */
        if (message.comment !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.comment);
        /* pr.v3.InternalStatus internal_status = 13; */
        if (message.internalStatus !== 0)
            writer.tag(13, WireType.Varint).int32(message.internalStatus);
        /* float discount = 14; */
        if (message.discount !== 0)
            writer.tag(14, WireType.Bit32).float(message.discount);
        /* pr.v3.XvOrdersResp.User user = 15; */
        if (message.user)
            XvOrdersResp_User.internalBinaryWrite(message.user, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* repeated pr.v3.File order_files = 16; */
        for (let i = 0; i < message.orderFiles.length; i++)
            File.internalBinaryWrite(message.orderFiles[i], writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* repeated pr.v3.File work_files = 17; */
        for (let i = 0; i < message.workFiles.length; i++)
            File.internalBinaryWrite(message.workFiles[i], writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* bool view_mail_price = 18; */
        if (message.viewMailPrice !== false)
            writer.tag(18, WireType.Varint).bool(message.viewMailPrice);
        /* bool view_site_price = 19; */
        if (message.viewSitePrice !== false)
            writer.tag(19, WireType.Varint).bool(message.viewSitePrice);
        /* bool view_mail_pay = 20; */
        if (message.viewMailPay !== false)
            writer.tag(20, WireType.Varint).bool(message.viewMailPay);
        /* bool view_site_pay = 21; */
        if (message.viewSitePay !== false)
            writer.tag(21, WireType.Varint).bool(message.viewSitePay);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.XvOrdersResp.Order
 */
export const XvOrdersResp_Order = new XvOrdersResp_Order$Type();
// @generated message type with reflection information, may provide speed optimized methods
class XvSetOrderStatusReq$Type extends MessageType<XvSetOrderStatusReq> {
    constructor() {
        super("pr.v3.XvSetOrderStatusReq", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "status", kind: "enum", T: () => ["pr.v3.InternalStatus", InternalStatus, "INTERNAL_STATUS_"] },
            { no: 3, name: "price", kind: "scalar", opt: true, T: 2 /*ScalarType.FLOAT*/ },
            { no: 4, name: "send_mail_on_cancel", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<XvSetOrderStatusReq>): XvSetOrderStatusReq {
        const message = { id: 0n, status: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<XvSetOrderStatusReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: XvSetOrderStatusReq): XvSetOrderStatusReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* pr.v3.InternalStatus status */ 2:
                    message.status = reader.int32();
                    break;
                case /* optional float price */ 3:
                    message.price = reader.float();
                    break;
                case /* optional bool send_mail_on_cancel */ 4:
                    message.sendMailOnCancel = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: XvSetOrderStatusReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* pr.v3.InternalStatus status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* optional float price = 3; */
        if (message.price !== undefined)
            writer.tag(3, WireType.Bit32).float(message.price);
        /* optional bool send_mail_on_cancel = 4; */
        if (message.sendMailOnCancel !== undefined)
            writer.tag(4, WireType.Varint).bool(message.sendMailOnCancel);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.XvSetOrderStatusReq
 */
export const XvSetOrderStatusReq = new XvSetOrderStatusReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class XvSetOrderStatusResp$Type extends MessageType<XvSetOrderStatusResp> {
    constructor() {
        super("pr.v3.XvSetOrderStatusResp", []);
    }
    create(value?: PartialMessage<XvSetOrderStatusResp>): XvSetOrderStatusResp {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<XvSetOrderStatusResp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: XvSetOrderStatusResp): XvSetOrderStatusResp {
        return target ?? this.create();
    }
    internalBinaryWrite(message: XvSetOrderStatusResp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.XvSetOrderStatusResp
 */
export const XvSetOrderStatusResp = new XvSetOrderStatusResp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrderToCheckReq$Type extends MessageType<OrderToCheckReq> {
    constructor() {
        super("pr.v3.OrderToCheckReq", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "file_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<OrderToCheckReq>): OrderToCheckReq {
        const message = { id: 0n, fileIds: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OrderToCheckReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrderToCheckReq): OrderToCheckReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* repeated int64 file_ids */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.fileIds.push(reader.int64().toBigInt());
                    else
                        message.fileIds.push(reader.int64().toBigInt());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrderToCheckReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* repeated int64 file_ids = 2; */
        if (message.fileIds.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.fileIds.length; i++)
                writer.int64(message.fileIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.OrderToCheckReq
 */
export const OrderToCheckReq = new OrderToCheckReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrderToCheckResp$Type extends MessageType<OrderToCheckResp> {
    constructor() {
        super("pr.v3.OrderToCheckResp", []);
    }
    create(value?: PartialMessage<OrderToCheckResp>): OrderToCheckResp {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OrderToCheckResp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrderToCheckResp): OrderToCheckResp {
        return target ?? this.create();
    }
    internalBinaryWrite(message: OrderToCheckResp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.OrderToCheckResp
 */
export const OrderToCheckResp = new OrderToCheckResp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrdersReq$Type extends MessageType<OrdersReq> {
    constructor() {
        super("pr.v3.OrdersReq", []);
    }
    create(value?: PartialMessage<OrdersReq>): OrdersReq {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OrdersReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrdersReq): OrdersReq {
        return target ?? this.create();
    }
    internalBinaryWrite(message: OrdersReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.OrdersReq
 */
export const OrdersReq = new OrdersReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrdersResp$Type extends MessageType<OrdersResp> {
    constructor() {
        super("pr.v3.OrdersResp", [
            { no: 1, name: "orders", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => OrdersResp_Order }
        ]);
    }
    create(value?: PartialMessage<OrdersResp>): OrdersResp {
        const message = { orders: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OrdersResp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrdersResp): OrdersResp {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated pr.v3.OrdersResp.Order orders */ 1:
                    message.orders.push(OrdersResp_Order.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrdersResp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated pr.v3.OrdersResp.Order orders = 1; */
        for (let i = 0; i < message.orders.length; i++)
            OrdersResp_Order.internalBinaryWrite(message.orders[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.OrdersResp
 */
export const OrdersResp = new OrdersResp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrdersResp_User$Type extends MessageType<OrdersResp_User> {
    constructor() {
        super("pr.v3.OrdersResp.User", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OrdersResp_User>): OrdersResp_User {
        const message = { id: 0n, name: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OrdersResp_User>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrdersResp_User): OrdersResp_User {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrdersResp_User, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.OrdersResp.User
 */
export const OrdersResp_User = new OrdersResp_User$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrdersResp_SettedPrice$Type extends MessageType<OrdersResp_SettedPrice> {
    constructor() {
        super("pr.v3.OrdersResp.SettedPrice", [
            { no: 1, name: "user", kind: "message", T: () => OrdersResp_User },
            { no: 2, name: "price", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
    create(value?: PartialMessage<OrdersResp_SettedPrice>): OrdersResp_SettedPrice {
        const message = { price: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OrdersResp_SettedPrice>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrdersResp_SettedPrice): OrdersResp_SettedPrice {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* pr.v3.OrdersResp.User user */ 1:
                    message.user = OrdersResp_User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                case /* float price */ 2:
                    message.price = reader.float();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrdersResp_SettedPrice, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* pr.v3.OrdersResp.User user = 1; */
        if (message.user)
            OrdersResp_User.internalBinaryWrite(message.user, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* float price = 2; */
        if (message.price !== 0)
            writer.tag(2, WireType.Bit32).float(message.price);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.OrdersResp.SettedPrice
 */
export const OrdersResp_SettedPrice = new OrdersResp_SettedPrice$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrdersResp_Order$Type extends MessageType<OrdersResp_Order> {
    constructor() {
        super("pr.v3.OrdersResp.Order", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "lesson", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "theme", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "size", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "demand", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "finish_date", kind: "message", T: () => Timestamp },
            { no: 9, name: "publish_date", kind: "message", T: () => Timestamp },
            { no: 10, name: "price", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 11, name: "order_files", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => File },
            { no: 12, name: "work_files", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => File },
            { no: 13, name: "user", kind: "message", T: () => OrdersResp_User },
            { no: 14, name: "internal_status", kind: "enum", T: () => ["pr.v3.PrInternalStatus", PrInternalStatus, "PR_INTERNAL_STATUS_"] },
            { no: 15, name: "setted_prices", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => OrdersResp_SettedPrice },
            { no: 16, name: "checks", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<OrdersResp_Order>): OrdersResp_Order {
        const message = { id: 0n, number: "", type: "", lesson: "", theme: "", size: "", demand: "", price: 0, orderFiles: [], workFiles: [], internalStatus: 0, settedPrices: [], checks: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OrdersResp_Order>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrdersResp_Order): OrdersResp_Order {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* string number */ 2:
                    message.number = reader.string();
                    break;
                case /* string type */ 3:
                    message.type = reader.string();
                    break;
                case /* string lesson */ 4:
                    message.lesson = reader.string();
                    break;
                case /* string theme */ 5:
                    message.theme = reader.string();
                    break;
                case /* string size */ 6:
                    message.size = reader.string();
                    break;
                case /* string demand */ 7:
                    message.demand = reader.string();
                    break;
                case /* google.protobuf.Timestamp finish_date */ 8:
                    message.finishDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.finishDate);
                    break;
                case /* google.protobuf.Timestamp publish_date */ 9:
                    message.publishDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.publishDate);
                    break;
                case /* float price */ 10:
                    message.price = reader.float();
                    break;
                case /* repeated pr.v3.File order_files */ 11:
                    message.orderFiles.push(File.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated pr.v3.File work_files */ 12:
                    message.workFiles.push(File.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* pr.v3.OrdersResp.User user */ 13:
                    message.user = OrdersResp_User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                case /* pr.v3.PrInternalStatus internal_status */ 14:
                    message.internalStatus = reader.int32();
                    break;
                case /* repeated pr.v3.OrdersResp.SettedPrice setted_prices */ 15:
                    message.settedPrices.push(OrdersResp_SettedPrice.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated bool checks */ 16:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.checks.push(reader.bool());
                    else
                        message.checks.push(reader.bool());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrdersResp_Order, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* string number = 2; */
        if (message.number !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.number);
        /* string type = 3; */
        if (message.type !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.type);
        /* string lesson = 4; */
        if (message.lesson !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.lesson);
        /* string theme = 5; */
        if (message.theme !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.theme);
        /* string size = 6; */
        if (message.size !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.size);
        /* string demand = 7; */
        if (message.demand !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.demand);
        /* google.protobuf.Timestamp finish_date = 8; */
        if (message.finishDate)
            Timestamp.internalBinaryWrite(message.finishDate, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp publish_date = 9; */
        if (message.publishDate)
            Timestamp.internalBinaryWrite(message.publishDate, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* float price = 10; */
        if (message.price !== 0)
            writer.tag(10, WireType.Bit32).float(message.price);
        /* repeated pr.v3.File order_files = 11; */
        for (let i = 0; i < message.orderFiles.length; i++)
            File.internalBinaryWrite(message.orderFiles[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* repeated pr.v3.File work_files = 12; */
        for (let i = 0; i < message.workFiles.length; i++)
            File.internalBinaryWrite(message.workFiles[i], writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* pr.v3.OrdersResp.User user = 13; */
        if (message.user)
            OrdersResp_User.internalBinaryWrite(message.user, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* pr.v3.PrInternalStatus internal_status = 14; */
        if (message.internalStatus !== 0)
            writer.tag(14, WireType.Varint).int32(message.internalStatus);
        /* repeated pr.v3.OrdersResp.SettedPrice setted_prices = 15; */
        for (let i = 0; i < message.settedPrices.length; i++)
            OrdersResp_SettedPrice.internalBinaryWrite(message.settedPrices[i], writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* repeated bool checks = 16; */
        if (message.checks.length) {
            writer.tag(16, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.checks.length; i++)
                writer.bool(message.checks[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.OrdersResp.Order
 */
export const OrdersResp_Order = new OrdersResp_Order$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteFileReq$Type extends MessageType<DeleteFileReq> {
    constructor() {
        super("pr.v3.DeleteFileReq", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "order_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "type", kind: "enum", T: () => ["pr.v3.DeleteFileReq.FileType", DeleteFileReq_FileType, "FILE_TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<DeleteFileReq>): DeleteFileReq {
        const message = { id: 0n, orderId: 0n, type: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DeleteFileReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteFileReq): DeleteFileReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* int64 order_id */ 2:
                    message.orderId = reader.int64().toBigInt();
                    break;
                case /* pr.v3.DeleteFileReq.FileType type */ 3:
                    message.type = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteFileReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* int64 order_id = 2; */
        if (message.orderId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.orderId);
        /* pr.v3.DeleteFileReq.FileType type = 3; */
        if (message.type !== 0)
            writer.tag(3, WireType.Varint).int32(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.DeleteFileReq
 */
export const DeleteFileReq = new DeleteFileReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteFileResp$Type extends MessageType<DeleteFileResp> {
    constructor() {
        super("pr.v3.DeleteFileResp", []);
    }
    create(value?: PartialMessage<DeleteFileResp>): DeleteFileResp {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DeleteFileResp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteFileResp): DeleteFileResp {
        return target ?? this.create();
    }
    internalBinaryWrite(message: DeleteFileResp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.DeleteFileResp
 */
export const DeleteFileResp = new DeleteFileResp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddMoneyReq$Type extends MessageType<AddMoneyReq> {
    constructor() {
        super("pr.v3.AddMoneyReq", [
            { no: 1, name: "type", kind: "enum", T: () => ["pr.v3.AddMoneyReq.Type", AddMoneyReq_Type, "TYPE_"] },
            { no: 2, name: "amount", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 3, name: "comment", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AddMoneyReq>): AddMoneyReq {
        const message = { type: 0, amount: 0, comment: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AddMoneyReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AddMoneyReq): AddMoneyReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* pr.v3.AddMoneyReq.Type type */ 1:
                    message.type = reader.int32();
                    break;
                case /* float amount */ 2:
                    message.amount = reader.float();
                    break;
                case /* string comment */ 3:
                    message.comment = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AddMoneyReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* pr.v3.AddMoneyReq.Type type = 1; */
        if (message.type !== 0)
            writer.tag(1, WireType.Varint).int32(message.type);
        /* float amount = 2; */
        if (message.amount !== 0)
            writer.tag(2, WireType.Bit32).float(message.amount);
        /* string comment = 3; */
        if (message.comment !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.comment);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.AddMoneyReq
 */
export const AddMoneyReq = new AddMoneyReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddMoneyResp$Type extends MessageType<AddMoneyResp> {
    constructor() {
        super("pr.v3.AddMoneyResp", []);
    }
    create(value?: PartialMessage<AddMoneyResp>): AddMoneyResp {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AddMoneyResp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AddMoneyResp): AddMoneyResp {
        return target ?? this.create();
    }
    internalBinaryWrite(message: AddMoneyResp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.AddMoneyResp
 */
export const AddMoneyResp = new AddMoneyResp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrderToAdmReq$Type extends MessageType<OrderToAdmReq> {
    constructor() {
        super("pr.v3.OrderToAdmReq", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<OrderToAdmReq>): OrderToAdmReq {
        const message = { id: 0n };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OrderToAdmReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrderToAdmReq): OrderToAdmReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrderToAdmReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.OrderToAdmReq
 */
export const OrderToAdmReq = new OrderToAdmReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrderToAdmResp$Type extends MessageType<OrderToAdmResp> {
    constructor() {
        super("pr.v3.OrderToAdmResp", [
            { no: 1, name: "order", kind: "message", T: () => OrderToAdmResp_Order }
        ]);
    }
    create(value?: PartialMessage<OrderToAdmResp>): OrderToAdmResp {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OrderToAdmResp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrderToAdmResp): OrderToAdmResp {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* pr.v3.OrderToAdmResp.Order order */ 1:
                    message.order = OrderToAdmResp_Order.internalBinaryRead(reader, reader.uint32(), options, message.order);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrderToAdmResp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* pr.v3.OrderToAdmResp.Order order = 1; */
        if (message.order)
            OrderToAdmResp_Order.internalBinaryWrite(message.order, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.OrderToAdmResp
 */
export const OrderToAdmResp = new OrderToAdmResp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrderToAdmResp_Order$Type extends MessageType<OrderToAdmResp_Order> {
    constructor() {
        super("pr.v3.OrderToAdmResp.Order", [
            { no: 1, name: "number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "lesson", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "theme", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "demand", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "size", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "finish_date", kind: "message", T: () => Timestamp },
            { no: 8, name: "price", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 9, name: "user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 10, name: "economics", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "humanitary", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "juridas", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "languages", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "technology", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 15, name: "order_files", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => File },
            { no: 16, name: "work_files", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => File },
            { no: 17, name: "deleted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<OrderToAdmResp_Order>): OrderToAdmResp_Order {
        const message = { number: "", type: "", lesson: "", theme: "", demand: "", size: "", price: 0, userId: 0n, economics: false, humanitary: false, juridas: false, languages: false, technology: false, orderFiles: [], workFiles: [], deleted: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OrderToAdmResp_Order>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrderToAdmResp_Order): OrderToAdmResp_Order {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string number */ 1:
                    message.number = reader.string();
                    break;
                case /* string type */ 2:
                    message.type = reader.string();
                    break;
                case /* string lesson */ 3:
                    message.lesson = reader.string();
                    break;
                case /* string theme */ 4:
                    message.theme = reader.string();
                    break;
                case /* string demand */ 5:
                    message.demand = reader.string();
                    break;
                case /* string size */ 6:
                    message.size = reader.string();
                    break;
                case /* google.protobuf.Timestamp finish_date */ 7:
                    message.finishDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.finishDate);
                    break;
                case /* float price */ 8:
                    message.price = reader.float();
                    break;
                case /* int64 user_id */ 9:
                    message.userId = reader.int64().toBigInt();
                    break;
                case /* bool economics */ 10:
                    message.economics = reader.bool();
                    break;
                case /* bool humanitary */ 11:
                    message.humanitary = reader.bool();
                    break;
                case /* bool juridas */ 12:
                    message.juridas = reader.bool();
                    break;
                case /* bool languages */ 13:
                    message.languages = reader.bool();
                    break;
                case /* bool technology */ 14:
                    message.technology = reader.bool();
                    break;
                case /* repeated pr.v3.File order_files */ 15:
                    message.orderFiles.push(File.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated pr.v3.File work_files */ 16:
                    message.workFiles.push(File.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool deleted */ 17:
                    message.deleted = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrderToAdmResp_Order, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string number = 1; */
        if (message.number !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.number);
        /* string type = 2; */
        if (message.type !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.type);
        /* string lesson = 3; */
        if (message.lesson !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.lesson);
        /* string theme = 4; */
        if (message.theme !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.theme);
        /* string demand = 5; */
        if (message.demand !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.demand);
        /* string size = 6; */
        if (message.size !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.size);
        /* google.protobuf.Timestamp finish_date = 7; */
        if (message.finishDate)
            Timestamp.internalBinaryWrite(message.finishDate, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* float price = 8; */
        if (message.price !== 0)
            writer.tag(8, WireType.Bit32).float(message.price);
        /* int64 user_id = 9; */
        if (message.userId !== 0n)
            writer.tag(9, WireType.Varint).int64(message.userId);
        /* bool economics = 10; */
        if (message.economics !== false)
            writer.tag(10, WireType.Varint).bool(message.economics);
        /* bool humanitary = 11; */
        if (message.humanitary !== false)
            writer.tag(11, WireType.Varint).bool(message.humanitary);
        /* bool juridas = 12; */
        if (message.juridas !== false)
            writer.tag(12, WireType.Varint).bool(message.juridas);
        /* bool languages = 13; */
        if (message.languages !== false)
            writer.tag(13, WireType.Varint).bool(message.languages);
        /* bool technology = 14; */
        if (message.technology !== false)
            writer.tag(14, WireType.Varint).bool(message.technology);
        /* repeated pr.v3.File order_files = 15; */
        for (let i = 0; i < message.orderFiles.length; i++)
            File.internalBinaryWrite(message.orderFiles[i], writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* repeated pr.v3.File work_files = 16; */
        for (let i = 0; i < message.workFiles.length; i++)
            File.internalBinaryWrite(message.workFiles[i], writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* bool deleted = 17; */
        if (message.deleted !== false)
            writer.tag(17, WireType.Varint).bool(message.deleted);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.OrderToAdmResp.Order
 */
export const OrderToAdmResp_Order = new OrderToAdmResp_Order$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateOrderReq$Type extends MessageType<UpdateOrderReq> {
    constructor() {
        super("pr.v3.UpdateOrderReq", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "order", kind: "message", T: () => UpdateOrderReq_Order }
        ]);
    }
    create(value?: PartialMessage<UpdateOrderReq>): UpdateOrderReq {
        const message = { id: 0n };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<UpdateOrderReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateOrderReq): UpdateOrderReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* pr.v3.UpdateOrderReq.Order order */ 2:
                    message.order = UpdateOrderReq_Order.internalBinaryRead(reader, reader.uint32(), options, message.order);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateOrderReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* pr.v3.UpdateOrderReq.Order order = 2; */
        if (message.order)
            UpdateOrderReq_Order.internalBinaryWrite(message.order, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.UpdateOrderReq
 */
export const UpdateOrderReq = new UpdateOrderReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateOrderReq_Order$Type extends MessageType<UpdateOrderReq_Order> {
    constructor() {
        super("pr.v3.UpdateOrderReq.Order", [
            { no: 1, name: "number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "lesson", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "theme", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "demand", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "size", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "finish_date", kind: "message", T: () => Timestamp },
            { no: 8, name: "price", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 9, name: "user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 10, name: "economics", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "humanitary", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "juridas", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "languages", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "technology", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 15, name: "deleted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 16, name: "order_files", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateOrderReq_Order>): UpdateOrderReq_Order {
        const message = { number: "", type: "", lesson: "", theme: "", demand: "", size: "", price: 0, userId: 0n, economics: false, humanitary: false, juridas: false, languages: false, technology: false, deleted: false, orderFiles: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<UpdateOrderReq_Order>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateOrderReq_Order): UpdateOrderReq_Order {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string number */ 1:
                    message.number = reader.string();
                    break;
                case /* string type */ 2:
                    message.type = reader.string();
                    break;
                case /* string lesson */ 3:
                    message.lesson = reader.string();
                    break;
                case /* string theme */ 4:
                    message.theme = reader.string();
                    break;
                case /* string demand */ 5:
                    message.demand = reader.string();
                    break;
                case /* string size */ 6:
                    message.size = reader.string();
                    break;
                case /* google.protobuf.Timestamp finish_date */ 7:
                    message.finishDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.finishDate);
                    break;
                case /* float price */ 8:
                    message.price = reader.float();
                    break;
                case /* int64 user_id */ 9:
                    message.userId = reader.int64().toBigInt();
                    break;
                case /* bool economics */ 10:
                    message.economics = reader.bool();
                    break;
                case /* bool humanitary */ 11:
                    message.humanitary = reader.bool();
                    break;
                case /* bool juridas */ 12:
                    message.juridas = reader.bool();
                    break;
                case /* bool languages */ 13:
                    message.languages = reader.bool();
                    break;
                case /* bool technology */ 14:
                    message.technology = reader.bool();
                    break;
                case /* bool deleted */ 15:
                    message.deleted = reader.bool();
                    break;
                case /* repeated int64 order_files */ 16:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.orderFiles.push(reader.int64().toBigInt());
                    else
                        message.orderFiles.push(reader.int64().toBigInt());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateOrderReq_Order, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string number = 1; */
        if (message.number !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.number);
        /* string type = 2; */
        if (message.type !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.type);
        /* string lesson = 3; */
        if (message.lesson !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.lesson);
        /* string theme = 4; */
        if (message.theme !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.theme);
        /* string demand = 5; */
        if (message.demand !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.demand);
        /* string size = 6; */
        if (message.size !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.size);
        /* google.protobuf.Timestamp finish_date = 7; */
        if (message.finishDate)
            Timestamp.internalBinaryWrite(message.finishDate, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* float price = 8; */
        if (message.price !== 0)
            writer.tag(8, WireType.Bit32).float(message.price);
        /* int64 user_id = 9; */
        if (message.userId !== 0n)
            writer.tag(9, WireType.Varint).int64(message.userId);
        /* bool economics = 10; */
        if (message.economics !== false)
            writer.tag(10, WireType.Varint).bool(message.economics);
        /* bool humanitary = 11; */
        if (message.humanitary !== false)
            writer.tag(11, WireType.Varint).bool(message.humanitary);
        /* bool juridas = 12; */
        if (message.juridas !== false)
            writer.tag(12, WireType.Varint).bool(message.juridas);
        /* bool languages = 13; */
        if (message.languages !== false)
            writer.tag(13, WireType.Varint).bool(message.languages);
        /* bool technology = 14; */
        if (message.technology !== false)
            writer.tag(14, WireType.Varint).bool(message.technology);
        /* bool deleted = 15; */
        if (message.deleted !== false)
            writer.tag(15, WireType.Varint).bool(message.deleted);
        /* repeated int64 order_files = 16; */
        if (message.orderFiles.length) {
            writer.tag(16, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.orderFiles.length; i++)
                writer.int64(message.orderFiles[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.UpdateOrderReq.Order
 */
export const UpdateOrderReq_Order = new UpdateOrderReq_Order$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateOrderResp$Type extends MessageType<UpdateOrderResp> {
    constructor() {
        super("pr.v3.UpdateOrderResp", []);
    }
    create(value?: PartialMessage<UpdateOrderResp>): UpdateOrderResp {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<UpdateOrderResp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateOrderResp): UpdateOrderResp {
        return target ?? this.create();
    }
    internalBinaryWrite(message: UpdateOrderResp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.UpdateOrderResp
 */
export const UpdateOrderResp = new UpdateOrderResp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrderPayedReq$Type extends MessageType<OrderPayedReq> {
    constructor() {
        super("pr.v3.OrderPayedReq", [
            { no: 1, name: "ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "pay_comment", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OrderPayedReq>): OrderPayedReq {
        const message = { ids: [], payComment: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OrderPayedReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrderPayedReq): OrderPayedReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 ids */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.ids.push(reader.int64().toBigInt());
                    else
                        message.ids.push(reader.int64().toBigInt());
                    break;
                case /* string pay_comment */ 2:
                    message.payComment = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrderPayedReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 ids = 1; */
        if (message.ids.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.ids.length; i++)
                writer.int64(message.ids[i]);
            writer.join();
        }
        /* string pay_comment = 2; */
        if (message.payComment !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.payComment);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.OrderPayedReq
 */
export const OrderPayedReq = new OrderPayedReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrderPayedResp$Type extends MessageType<OrderPayedResp> {
    constructor() {
        super("pr.v3.OrderPayedResp", []);
    }
    create(value?: PartialMessage<OrderPayedResp>): OrderPayedResp {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OrderPayedResp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrderPayedResp): OrderPayedResp {
        return target ?? this.create();
    }
    internalBinaryWrite(message: OrderPayedResp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.OrderPayedResp
 */
export const OrderPayedResp = new OrderPayedResp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrderAcceptPriceReq$Type extends MessageType<OrderAcceptPriceReq> {
    constructor() {
        super("pr.v3.OrderAcceptPriceReq", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "price", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
    create(value?: PartialMessage<OrderAcceptPriceReq>): OrderAcceptPriceReq {
        const message = { id: 0n, userId: 0n, price: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OrderAcceptPriceReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrderAcceptPriceReq): OrderAcceptPriceReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* int64 user_id */ 2:
                    message.userId = reader.int64().toBigInt();
                    break;
                case /* float price */ 3:
                    message.price = reader.float();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrderAcceptPriceReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* int64 user_id = 2; */
        if (message.userId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.userId);
        /* float price = 3; */
        if (message.price !== 0)
            writer.tag(3, WireType.Bit32).float(message.price);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.OrderAcceptPriceReq
 */
export const OrderAcceptPriceReq = new OrderAcceptPriceReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrderAcceptPriceResp$Type extends MessageType<OrderAcceptPriceResp> {
    constructor() {
        super("pr.v3.OrderAcceptPriceResp", []);
    }
    create(value?: PartialMessage<OrderAcceptPriceResp>): OrderAcceptPriceResp {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OrderAcceptPriceResp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrderAcceptPriceResp): OrderAcceptPriceResp {
        return target ?? this.create();
    }
    internalBinaryWrite(message: OrderAcceptPriceResp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.OrderAcceptPriceResp
 */
export const OrderAcceptPriceResp = new OrderAcceptPriceResp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class XvOrdersHistoryReq$Type extends MessageType<XvOrdersHistoryReq> {
    constructor() {
        super("pr.v3.XvOrdersHistoryReq", []);
    }
    create(value?: PartialMessage<XvOrdersHistoryReq>): XvOrdersHistoryReq {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<XvOrdersHistoryReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: XvOrdersHistoryReq): XvOrdersHistoryReq {
        return target ?? this.create();
    }
    internalBinaryWrite(message: XvOrdersHistoryReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.XvOrdersHistoryReq
 */
export const XvOrdersHistoryReq = new XvOrdersHistoryReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class XvOrdersHistoryResp$Type extends MessageType<XvOrdersHistoryResp> {
    constructor() {
        super("pr.v3.XvOrdersHistoryResp", [
            { no: 1, name: "orders", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => XvOrdersHistoryResp_Order }
        ]);
    }
    create(value?: PartialMessage<XvOrdersHistoryResp>): XvOrdersHistoryResp {
        const message = { orders: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<XvOrdersHistoryResp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: XvOrdersHistoryResp): XvOrdersHistoryResp {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated pr.v3.XvOrdersHistoryResp.Order orders */ 1:
                    message.orders.push(XvOrdersHistoryResp_Order.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: XvOrdersHistoryResp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated pr.v3.XvOrdersHistoryResp.Order orders = 1; */
        for (let i = 0; i < message.orders.length; i++)
            XvOrdersHistoryResp_Order.internalBinaryWrite(message.orders[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.XvOrdersHistoryResp
 */
export const XvOrdersHistoryResp = new XvOrdersHistoryResp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class XvOrdersHistoryResp_Order$Type extends MessageType<XvOrdersHistoryResp_Order> {
    constructor() {
        super("pr.v3.XvOrdersHistoryResp.Order", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "season_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "lesson", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "internal_status", kind: "enum", T: () => ["pr.v3.InternalStatus", InternalStatus, "INTERNAL_STATUS_"] }
        ]);
    }
    create(value?: PartialMessage<XvOrdersHistoryResp_Order>): XvOrdersHistoryResp_Order {
        const message = { id: 0n, seasonId: 0n, type: "", lesson: "", internalStatus: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<XvOrdersHistoryResp_Order>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: XvOrdersHistoryResp_Order): XvOrdersHistoryResp_Order {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* int64 season_id */ 2:
                    message.seasonId = reader.int64().toBigInt();
                    break;
                case /* string type */ 3:
                    message.type = reader.string();
                    break;
                case /* string lesson */ 4:
                    message.lesson = reader.string();
                    break;
                case /* pr.v3.InternalStatus internal_status */ 13:
                    message.internalStatus = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: XvOrdersHistoryResp_Order, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* int64 season_id = 2; */
        if (message.seasonId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.seasonId);
        /* string type = 3; */
        if (message.type !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.type);
        /* string lesson = 4; */
        if (message.lesson !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.lesson);
        /* pr.v3.InternalStatus internal_status = 13; */
        if (message.internalStatus !== 0)
            writer.tag(13, WireType.Varint).int32(message.internalStatus);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.XvOrdersHistoryResp.Order
 */
export const XvOrdersHistoryResp_Order = new XvOrdersHistoryResp_Order$Type();
// @generated message type with reflection information, may provide speed optimized methods
class XvOrderReq$Type extends MessageType<XvOrderReq> {
    constructor() {
        super("pr.v3.XvOrderReq", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<XvOrderReq>): XvOrderReq {
        const message = { id: 0n };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<XvOrderReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: XvOrderReq): XvOrderReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: XvOrderReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.XvOrderReq
 */
export const XvOrderReq = new XvOrderReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class XvOrderResp$Type extends MessageType<XvOrderResp> {
    constructor() {
        super("pr.v3.XvOrderResp", [
            { no: 1, name: "order", kind: "message", T: () => XvOrderResp_Order }
        ]);
    }
    create(value?: PartialMessage<XvOrderResp>): XvOrderResp {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<XvOrderResp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: XvOrderResp): XvOrderResp {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* pr.v3.XvOrderResp.Order order */ 1:
                    message.order = XvOrderResp_Order.internalBinaryRead(reader, reader.uint32(), options, message.order);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: XvOrderResp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* pr.v3.XvOrderResp.Order order = 1; */
        if (message.order)
            XvOrderResp_Order.internalBinaryWrite(message.order, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.XvOrderResp
 */
export const XvOrderResp = new XvOrderResp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class XvOrderResp_Order$Type extends MessageType<XvOrderResp_Order> {
    constructor() {
        super("pr.v3.XvOrderResp.Order", [
            { no: 1, name: "season_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "lesson", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "theme", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "size", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "demand", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "finish_date", kind: "message", T: () => Timestamp },
            { no: 8, name: "price", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 9, name: "prepayment", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 10, name: "comment", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "discount", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 12, name: "order_files", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => File },
            { no: 13, name: "work_files", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => File }
        ]);
    }
    create(value?: PartialMessage<XvOrderResp_Order>): XvOrderResp_Order {
        const message = { seasonId: 0n, type: "", lesson: "", theme: "", size: "", demand: "", price: 0, prepayment: 0, comment: "", discount: 0, orderFiles: [], workFiles: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<XvOrderResp_Order>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: XvOrderResp_Order): XvOrderResp_Order {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 season_id */ 1:
                    message.seasonId = reader.int64().toBigInt();
                    break;
                case /* string type */ 2:
                    message.type = reader.string();
                    break;
                case /* string lesson */ 3:
                    message.lesson = reader.string();
                    break;
                case /* string theme */ 4:
                    message.theme = reader.string();
                    break;
                case /* string size */ 5:
                    message.size = reader.string();
                    break;
                case /* string demand */ 6:
                    message.demand = reader.string();
                    break;
                case /* google.protobuf.Timestamp finish_date */ 7:
                    message.finishDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.finishDate);
                    break;
                case /* float price */ 8:
                    message.price = reader.float();
                    break;
                case /* float prepayment */ 9:
                    message.prepayment = reader.float();
                    break;
                case /* string comment */ 10:
                    message.comment = reader.string();
                    break;
                case /* float discount */ 11:
                    message.discount = reader.float();
                    break;
                case /* repeated pr.v3.File order_files */ 12:
                    message.orderFiles.push(File.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated pr.v3.File work_files */ 13:
                    message.workFiles.push(File.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: XvOrderResp_Order, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 season_id = 1; */
        if (message.seasonId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.seasonId);
        /* string type = 2; */
        if (message.type !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.type);
        /* string lesson = 3; */
        if (message.lesson !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.lesson);
        /* string theme = 4; */
        if (message.theme !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.theme);
        /* string size = 5; */
        if (message.size !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.size);
        /* string demand = 6; */
        if (message.demand !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.demand);
        /* google.protobuf.Timestamp finish_date = 7; */
        if (message.finishDate)
            Timestamp.internalBinaryWrite(message.finishDate, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* float price = 8; */
        if (message.price !== 0)
            writer.tag(8, WireType.Bit32).float(message.price);
        /* float prepayment = 9; */
        if (message.prepayment !== 0)
            writer.tag(9, WireType.Bit32).float(message.prepayment);
        /* string comment = 10; */
        if (message.comment !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.comment);
        /* float discount = 11; */
        if (message.discount !== 0)
            writer.tag(11, WireType.Bit32).float(message.discount);
        /* repeated pr.v3.File order_files = 12; */
        for (let i = 0; i < message.orderFiles.length; i++)
            File.internalBinaryWrite(message.orderFiles[i], writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* repeated pr.v3.File work_files = 13; */
        for (let i = 0; i < message.workFiles.length; i++)
            File.internalBinaryWrite(message.workFiles[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.XvOrderResp.Order
 */
export const XvOrderResp_Order = new XvOrderResp_Order$Type();
// @generated message type with reflection information, may provide speed optimized methods
class XvUpdateOrderReq$Type extends MessageType<XvUpdateOrderReq> {
    constructor() {
        super("pr.v3.XvUpdateOrderReq", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "order", kind: "message", T: () => XvUpdateOrderReq_Order }
        ]);
    }
    create(value?: PartialMessage<XvUpdateOrderReq>): XvUpdateOrderReq {
        const message = { id: 0n };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<XvUpdateOrderReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: XvUpdateOrderReq): XvUpdateOrderReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* pr.v3.XvUpdateOrderReq.Order order */ 2:
                    message.order = XvUpdateOrderReq_Order.internalBinaryRead(reader, reader.uint32(), options, message.order);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: XvUpdateOrderReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* pr.v3.XvUpdateOrderReq.Order order = 2; */
        if (message.order)
            XvUpdateOrderReq_Order.internalBinaryWrite(message.order, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.XvUpdateOrderReq
 */
export const XvUpdateOrderReq = new XvUpdateOrderReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class XvUpdateOrderReq_Order$Type extends MessageType<XvUpdateOrderReq_Order> {
    constructor() {
        super("pr.v3.XvUpdateOrderReq.Order", [
            { no: 1, name: "season_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "lesson", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "theme", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "size", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "demand", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "finish_date", kind: "message", T: () => Timestamp },
            { no: 8, name: "price", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 9, name: "prepayment", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 10, name: "comment", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "discount", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 12, name: "work_files", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<XvUpdateOrderReq_Order>): XvUpdateOrderReq_Order {
        const message = { seasonId: 0n, type: "", lesson: "", theme: "", size: "", demand: "", price: 0, prepayment: 0, comment: "", discount: 0, workFiles: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<XvUpdateOrderReq_Order>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: XvUpdateOrderReq_Order): XvUpdateOrderReq_Order {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 season_id */ 1:
                    message.seasonId = reader.int64().toBigInt();
                    break;
                case /* string type */ 2:
                    message.type = reader.string();
                    break;
                case /* string lesson */ 3:
                    message.lesson = reader.string();
                    break;
                case /* string theme */ 4:
                    message.theme = reader.string();
                    break;
                case /* string size */ 5:
                    message.size = reader.string();
                    break;
                case /* string demand */ 6:
                    message.demand = reader.string();
                    break;
                case /* google.protobuf.Timestamp finish_date */ 7:
                    message.finishDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.finishDate);
                    break;
                case /* float price */ 8:
                    message.price = reader.float();
                    break;
                case /* float prepayment */ 9:
                    message.prepayment = reader.float();
                    break;
                case /* string comment */ 10:
                    message.comment = reader.string();
                    break;
                case /* float discount */ 11:
                    message.discount = reader.float();
                    break;
                case /* repeated int64 work_files */ 12:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.workFiles.push(reader.int64().toBigInt());
                    else
                        message.workFiles.push(reader.int64().toBigInt());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: XvUpdateOrderReq_Order, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 season_id = 1; */
        if (message.seasonId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.seasonId);
        /* string type = 2; */
        if (message.type !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.type);
        /* string lesson = 3; */
        if (message.lesson !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.lesson);
        /* string theme = 4; */
        if (message.theme !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.theme);
        /* string size = 5; */
        if (message.size !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.size);
        /* string demand = 6; */
        if (message.demand !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.demand);
        /* google.protobuf.Timestamp finish_date = 7; */
        if (message.finishDate)
            Timestamp.internalBinaryWrite(message.finishDate, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* float price = 8; */
        if (message.price !== 0)
            writer.tag(8, WireType.Bit32).float(message.price);
        /* float prepayment = 9; */
        if (message.prepayment !== 0)
            writer.tag(9, WireType.Bit32).float(message.prepayment);
        /* string comment = 10; */
        if (message.comment !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.comment);
        /* float discount = 11; */
        if (message.discount !== 0)
            writer.tag(11, WireType.Bit32).float(message.discount);
        /* repeated int64 work_files = 12; */
        if (message.workFiles.length) {
            writer.tag(12, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.workFiles.length; i++)
                writer.int64(message.workFiles[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.XvUpdateOrderReq.Order
 */
export const XvUpdateOrderReq_Order = new XvUpdateOrderReq_Order$Type();
// @generated message type with reflection information, may provide speed optimized methods
class XvUpdateOrderResp$Type extends MessageType<XvUpdateOrderResp> {
    constructor() {
        super("pr.v3.XvUpdateOrderResp", []);
    }
    create(value?: PartialMessage<XvUpdateOrderResp>): XvUpdateOrderResp {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<XvUpdateOrderResp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: XvUpdateOrderResp): XvUpdateOrderResp {
        return target ?? this.create();
    }
    internalBinaryWrite(message: XvUpdateOrderResp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.XvUpdateOrderResp
 */
export const XvUpdateOrderResp = new XvUpdateOrderResp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class XvDeleteFileReq$Type extends MessageType<XvDeleteFileReq> {
    constructor() {
        super("pr.v3.XvDeleteFileReq", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "order_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "type", kind: "enum", T: () => ["pr.v3.XvDeleteFileReq.FileType", XvDeleteFileReq_FileType, "FILE_TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<XvDeleteFileReq>): XvDeleteFileReq {
        const message = { id: 0n, orderId: 0n, type: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<XvDeleteFileReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: XvDeleteFileReq): XvDeleteFileReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* int64 order_id */ 2:
                    message.orderId = reader.int64().toBigInt();
                    break;
                case /* pr.v3.XvDeleteFileReq.FileType type */ 3:
                    message.type = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: XvDeleteFileReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* int64 order_id = 2; */
        if (message.orderId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.orderId);
        /* pr.v3.XvDeleteFileReq.FileType type = 3; */
        if (message.type !== 0)
            writer.tag(3, WireType.Varint).int32(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.XvDeleteFileReq
 */
export const XvDeleteFileReq = new XvDeleteFileReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class XvDeleteFileResp$Type extends MessageType<XvDeleteFileResp> {
    constructor() {
        super("pr.v3.XvDeleteFileResp", []);
    }
    create(value?: PartialMessage<XvDeleteFileResp>): XvDeleteFileResp {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<XvDeleteFileResp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: XvDeleteFileResp): XvDeleteFileResp {
        return target ?? this.create();
    }
    internalBinaryWrite(message: XvDeleteFileResp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.XvDeleteFileResp
 */
export const XvDeleteFileResp = new XvDeleteFileResp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsersReq$Type extends MessageType<UsersReq> {
    constructor() {
        super("pr.v3.UsersReq", []);
    }
    create(value?: PartialMessage<UsersReq>): UsersReq {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<UsersReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UsersReq): UsersReq {
        return target ?? this.create();
    }
    internalBinaryWrite(message: UsersReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.UsersReq
 */
export const UsersReq = new UsersReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsersResp$Type extends MessageType<UsersResp> {
    constructor() {
        super("pr.v3.UsersResp", [
            { no: 1, name: "users", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => UsersResp_User }
        ]);
    }
    create(value?: PartialMessage<UsersResp>): UsersResp {
        const message = { users: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<UsersResp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UsersResp): UsersResp {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated pr.v3.UsersResp.User users */ 1:
                    message.users.push(UsersResp_User.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UsersResp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated pr.v3.UsersResp.User users = 1; */
        for (let i = 0; i < message.users.length; i++)
            UsersResp_User.internalBinaryWrite(message.users[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.UsersResp
 */
export const UsersResp = new UsersResp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsersResp_User$Type extends MessageType<UsersResp_User> {
    constructor() {
        super("pr.v3.UsersResp.User", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "last_visit", kind: "message", T: () => Timestamp },
            { no: 4, name: "email_notify", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UsersResp_User>): UsersResp_User {
        const message = { id: 0n, name: "", emailNotify: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<UsersResp_User>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UsersResp_User): UsersResp_User {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* google.protobuf.Timestamp last_visit */ 3:
                    message.lastVisit = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastVisit);
                    break;
                case /* bool email_notify */ 4:
                    message.emailNotify = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UsersResp_User, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* google.protobuf.Timestamp last_visit = 3; */
        if (message.lastVisit)
            Timestamp.internalBinaryWrite(message.lastVisit, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* bool email_notify = 4; */
        if (message.emailNotify !== false)
            writer.tag(4, WireType.Varint).bool(message.emailNotify);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.UsersResp.User
 */
export const UsersResp_User = new UsersResp_User$Type();
// @generated message type with reflection information, may provide speed optimized methods
class XvAddFilesReq$Type extends MessageType<XvAddFilesReq> {
    constructor() {
        super("pr.v3.XvAddFilesReq", [
            { no: 1, name: "ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "order_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "type", kind: "enum", T: () => ["pr.v3.XvAddFilesReq.FileType", XvAddFilesReq_FileType, "FILE_TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<XvAddFilesReq>): XvAddFilesReq {
        const message = { ids: [], orderId: 0n, type: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<XvAddFilesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: XvAddFilesReq): XvAddFilesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 ids */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.ids.push(reader.int64().toBigInt());
                    else
                        message.ids.push(reader.int64().toBigInt());
                    break;
                case /* int64 order_id */ 2:
                    message.orderId = reader.int64().toBigInt();
                    break;
                case /* pr.v3.XvAddFilesReq.FileType type */ 3:
                    message.type = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: XvAddFilesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 ids = 1; */
        if (message.ids.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.ids.length; i++)
                writer.int64(message.ids[i]);
            writer.join();
        }
        /* int64 order_id = 2; */
        if (message.orderId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.orderId);
        /* pr.v3.XvAddFilesReq.FileType type = 3; */
        if (message.type !== 0)
            writer.tag(3, WireType.Varint).int32(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.XvAddFilesReq
 */
export const XvAddFilesReq = new XvAddFilesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class XvAddFilesResp$Type extends MessageType<XvAddFilesResp> {
    constructor() {
        super("pr.v3.XvAddFilesResp", []);
    }
    create(value?: PartialMessage<XvAddFilesResp>): XvAddFilesResp {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<XvAddFilesResp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: XvAddFilesResp): XvAddFilesResp {
        return target ?? this.create();
    }
    internalBinaryWrite(message: XvAddFilesResp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.XvAddFilesResp
 */
export const XvAddFilesResp = new XvAddFilesResp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrderHistoryToAdminReq$Type extends MessageType<OrderHistoryToAdminReq> {
    constructor() {
        super("pr.v3.OrderHistoryToAdminReq", []);
    }
    create(value?: PartialMessage<OrderHistoryToAdminReq>): OrderHistoryToAdminReq {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OrderHistoryToAdminReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrderHistoryToAdminReq): OrderHistoryToAdminReq {
        return target ?? this.create();
    }
    internalBinaryWrite(message: OrderHistoryToAdminReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.OrderHistoryToAdminReq
 */
export const OrderHistoryToAdminReq = new OrderHistoryToAdminReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrderHistoryToAdminResp$Type extends MessageType<OrderHistoryToAdminResp> {
    constructor() {
        super("pr.v3.OrderHistoryToAdminResp", [
            { no: 1, name: "orders", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => OrderHistoryToAdminResp_Order }
        ]);
    }
    create(value?: PartialMessage<OrderHistoryToAdminResp>): OrderHistoryToAdminResp {
        const message = { orders: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OrderHistoryToAdminResp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrderHistoryToAdminResp): OrderHistoryToAdminResp {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated pr.v3.OrderHistoryToAdminResp.Order orders */ 1:
                    message.orders.push(OrderHistoryToAdminResp_Order.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrderHistoryToAdminResp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated pr.v3.OrderHistoryToAdminResp.Order orders = 1; */
        for (let i = 0; i < message.orders.length; i++)
            OrderHistoryToAdminResp_Order.internalBinaryWrite(message.orders[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.OrderHistoryToAdminResp
 */
export const OrderHistoryToAdminResp = new OrderHistoryToAdminResp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrderHistoryToAdminResp_Order$Type extends MessageType<OrderHistoryToAdminResp_Order> {
    constructor() {
        super("pr.v3.OrderHistoryToAdminResp.Order", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "finish_date", kind: "message", T: () => Timestamp },
            { no: 5, name: "lesson", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<OrderHistoryToAdminResp_Order>): OrderHistoryToAdminResp_Order {
        const message = { id: 0n, number: "", type: "", lesson: "", userId: 0n };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OrderHistoryToAdminResp_Order>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrderHistoryToAdminResp_Order): OrderHistoryToAdminResp_Order {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* string number */ 2:
                    message.number = reader.string();
                    break;
                case /* string type */ 3:
                    message.type = reader.string();
                    break;
                case /* google.protobuf.Timestamp finish_date */ 4:
                    message.finishDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.finishDate);
                    break;
                case /* string lesson */ 5:
                    message.lesson = reader.string();
                    break;
                case /* int64 user_id */ 6:
                    message.userId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrderHistoryToAdminResp_Order, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* string number = 2; */
        if (message.number !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.number);
        /* string type = 3; */
        if (message.type !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.type);
        /* google.protobuf.Timestamp finish_date = 4; */
        if (message.finishDate)
            Timestamp.internalBinaryWrite(message.finishDate, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string lesson = 5; */
        if (message.lesson !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.lesson);
        /* int64 user_id = 6; */
        if (message.userId !== 0n)
            writer.tag(6, WireType.Varint).int64(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.OrderHistoryToAdminResp.Order
 */
export const OrderHistoryToAdminResp_Order = new OrderHistoryToAdminResp_Order$Type();
// @generated message type with reflection information, may provide speed optimized methods
class XvUserOrdersReq$Type extends MessageType<XvUserOrdersReq> {
    constructor() {
        super("pr.v3.XvUserOrdersReq", [
            { no: 1, name: "user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<XvUserOrdersReq>): XvUserOrdersReq {
        const message = { userId: 0n };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<XvUserOrdersReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: XvUserOrdersReq): XvUserOrdersReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 user_id */ 1:
                    message.userId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: XvUserOrdersReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 user_id = 1; */
        if (message.userId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.XvUserOrdersReq
 */
export const XvUserOrdersReq = new XvUserOrdersReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class XvUserOrdersResp$Type extends MessageType<XvUserOrdersResp> {
    constructor() {
        super("pr.v3.XvUserOrdersResp", [
            { no: 1, name: "orders", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => XvUserOrdersResp_Order }
        ]);
    }
    create(value?: PartialMessage<XvUserOrdersResp>): XvUserOrdersResp {
        const message = { orders: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<XvUserOrdersResp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: XvUserOrdersResp): XvUserOrdersResp {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated pr.v3.XvUserOrdersResp.Order orders */ 1:
                    message.orders.push(XvUserOrdersResp_Order.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: XvUserOrdersResp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated pr.v3.XvUserOrdersResp.Order orders = 1; */
        for (let i = 0; i < message.orders.length; i++)
            XvUserOrdersResp_Order.internalBinaryWrite(message.orders[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.XvUserOrdersResp
 */
export const XvUserOrdersResp = new XvUserOrdersResp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class XvUserOrdersResp_Order$Type extends MessageType<XvUserOrdersResp_Order> {
    constructor() {
        super("pr.v3.XvUserOrdersResp.Order", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "season_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "lesson", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "internal_status", kind: "enum", T: () => ["pr.v3.InternalStatus", InternalStatus, "INTERNAL_STATUS_"] },
            { no: 6, name: "price", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
    create(value?: PartialMessage<XvUserOrdersResp_Order>): XvUserOrdersResp_Order {
        const message = { id: 0n, seasonId: 0n, type: "", lesson: "", internalStatus: 0, price: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<XvUserOrdersResp_Order>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: XvUserOrdersResp_Order): XvUserOrdersResp_Order {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* int64 season_id */ 2:
                    message.seasonId = reader.int64().toBigInt();
                    break;
                case /* string type */ 3:
                    message.type = reader.string();
                    break;
                case /* string lesson */ 4:
                    message.lesson = reader.string();
                    break;
                case /* pr.v3.InternalStatus internal_status */ 5:
                    message.internalStatus = reader.int32();
                    break;
                case /* float price */ 6:
                    message.price = reader.float();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: XvUserOrdersResp_Order, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* int64 season_id = 2; */
        if (message.seasonId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.seasonId);
        /* string type = 3; */
        if (message.type !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.type);
        /* string lesson = 4; */
        if (message.lesson !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.lesson);
        /* pr.v3.InternalStatus internal_status = 5; */
        if (message.internalStatus !== 0)
            writer.tag(5, WireType.Varint).int32(message.internalStatus);
        /* float price = 6; */
        if (message.price !== 0)
            writer.tag(6, WireType.Bit32).float(message.price);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.XvUserOrdersResp.Order
 */
export const XvUserOrdersResp_Order = new XvUserOrdersResp_Order$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserReq$Type extends MessageType<UserReq> {
    constructor() {
        super("pr.v3.UserReq", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<UserReq>): UserReq {
        const message = { id: 0n };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<UserReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserReq): UserReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.UserReq
 */
export const UserReq = new UserReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserResp$Type extends MessageType<UserResp> {
    constructor() {
        super("pr.v3.UserResp", [
            { no: 1, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "money", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "work", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "pay", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "phone", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "email_notify", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "economics", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "humanitary", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "juridas", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "languages", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "technology", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "register_date", kind: "message", T: () => Timestamp },
            { no: 14, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "last_visit", kind: "message", T: () => Timestamp },
            { no: 16, name: "ip", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UserResp>): UserResp {
        const message = { email: "", money: 0, name: "", work: 0n, pay: "", phone: "", emailNotify: false, economics: false, humanitary: false, juridas: false, languages: false, technology: false, notes: "", ip: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<UserResp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserResp): UserResp {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string email */ 1:
                    message.email = reader.string();
                    break;
                case /* float money */ 2:
                    message.money = reader.float();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* int64 work */ 4:
                    message.work = reader.int64().toBigInt();
                    break;
                case /* string pay */ 5:
                    message.pay = reader.string();
                    break;
                case /* string phone */ 6:
                    message.phone = reader.string();
                    break;
                case /* bool email_notify */ 7:
                    message.emailNotify = reader.bool();
                    break;
                case /* bool economics */ 8:
                    message.economics = reader.bool();
                    break;
                case /* bool humanitary */ 9:
                    message.humanitary = reader.bool();
                    break;
                case /* bool juridas */ 10:
                    message.juridas = reader.bool();
                    break;
                case /* bool languages */ 11:
                    message.languages = reader.bool();
                    break;
                case /* bool technology */ 12:
                    message.technology = reader.bool();
                    break;
                case /* google.protobuf.Timestamp register_date */ 13:
                    message.registerDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.registerDate);
                    break;
                case /* string notes */ 14:
                    message.notes = reader.string();
                    break;
                case /* google.protobuf.Timestamp last_visit */ 15:
                    message.lastVisit = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastVisit);
                    break;
                case /* string ip */ 16:
                    message.ip = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserResp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string email = 1; */
        if (message.email !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.email);
        /* float money = 2; */
        if (message.money !== 0)
            writer.tag(2, WireType.Bit32).float(message.money);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* int64 work = 4; */
        if (message.work !== 0n)
            writer.tag(4, WireType.Varint).int64(message.work);
        /* string pay = 5; */
        if (message.pay !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.pay);
        /* string phone = 6; */
        if (message.phone !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.phone);
        /* bool email_notify = 7; */
        if (message.emailNotify !== false)
            writer.tag(7, WireType.Varint).bool(message.emailNotify);
        /* bool economics = 8; */
        if (message.economics !== false)
            writer.tag(8, WireType.Varint).bool(message.economics);
        /* bool humanitary = 9; */
        if (message.humanitary !== false)
            writer.tag(9, WireType.Varint).bool(message.humanitary);
        /* bool juridas = 10; */
        if (message.juridas !== false)
            writer.tag(10, WireType.Varint).bool(message.juridas);
        /* bool languages = 11; */
        if (message.languages !== false)
            writer.tag(11, WireType.Varint).bool(message.languages);
        /* bool technology = 12; */
        if (message.technology !== false)
            writer.tag(12, WireType.Varint).bool(message.technology);
        /* google.protobuf.Timestamp register_date = 13; */
        if (message.registerDate)
            Timestamp.internalBinaryWrite(message.registerDate, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* string notes = 14; */
        if (message.notes !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.notes);
        /* google.protobuf.Timestamp last_visit = 15; */
        if (message.lastVisit)
            Timestamp.internalBinaryWrite(message.lastVisit, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* string ip = 16; */
        if (message.ip !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.ip);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.UserResp
 */
export const UserResp = new UserResp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class XvOrderPayNotifyReq$Type extends MessageType<XvOrderPayNotifyReq> {
    constructor() {
        super("pr.v3.XvOrderPayNotifyReq", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<XvOrderPayNotifyReq>): XvOrderPayNotifyReq {
        const message = { id: 0n };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<XvOrderPayNotifyReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: XvOrderPayNotifyReq): XvOrderPayNotifyReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: XvOrderPayNotifyReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.XvOrderPayNotifyReq
 */
export const XvOrderPayNotifyReq = new XvOrderPayNotifyReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class XvOrderPayNotifyResp$Type extends MessageType<XvOrderPayNotifyResp> {
    constructor() {
        super("pr.v3.XvOrderPayNotifyResp", []);
    }
    create(value?: PartialMessage<XvOrderPayNotifyResp>): XvOrderPayNotifyResp {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<XvOrderPayNotifyResp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: XvOrderPayNotifyResp): XvOrderPayNotifyResp {
        return target ?? this.create();
    }
    internalBinaryWrite(message: XvOrderPayNotifyResp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.XvOrderPayNotifyResp
 */
export const XvOrderPayNotifyResp = new XvOrderPayNotifyResp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuthRequest$Type extends MessageType<AuthRequest> {
    constructor() {
        super("pr.v3.AuthRequest", [
            { no: 1, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "password", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AuthRequest>): AuthRequest {
        const message = { email: "", password: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AuthRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AuthRequest): AuthRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string email */ 1:
                    message.email = reader.string();
                    break;
                case /* string password */ 2:
                    message.password = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AuthRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string email = 1; */
        if (message.email !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.email);
        /* string password = 2; */
        if (message.password !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.password);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.AuthRequest
 */
export const AuthRequest = new AuthRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuthResponse$Type extends MessageType<AuthResponse> {
    constructor() {
        super("pr.v3.AuthResponse", [
            { no: 1, name: "authorized", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AuthResponse>): AuthResponse {
        const message = { authorized: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AuthResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AuthResponse): AuthResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool authorized */ 1:
                    message.authorized = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AuthResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool authorized = 1; */
        if (message.authorized !== false)
            writer.tag(1, WireType.Varint).bool(message.authorized);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pr.v3.AuthResponse
 */
export const AuthResponse = new AuthResponse$Type();
/**
 * @generated ServiceType for protobuf service pr.v3.User
 */
export const User = new ServiceType("pr.v3.User", [
    { name: "OrderHistory", options: { "pr.v3.roles": { roles: ["ROLE_USER"] } }, I: OrderHistoryReq, O: OrderHistoryResp },
    { name: "Order", options: { "pr.v3.roles": { roles: ["ROLE_USER"] } }, I: OrderReq, O: OrderResp },
    { name: "OrderToCheck", options: { "pr.v3.roles": { roles: ["ROLE_USER"] } }, I: OrderToCheckReq, O: OrderToCheckResp }
]);
/**
 * @generated ServiceType for protobuf service pr.v3.Admin
 */
export const Admin = new ServiceType("pr.v3.Admin", [
    { name: "XvOrders", options: { "pr.v3.roles": { roles: ["ROLE_ADMIN"] } }, I: XvOrdersReq, O: XvOrdersResp },
    { name: "XvSetOrderStatus", options: { "pr.v3.roles": { roles: ["ROLE_ADMIN"] } }, I: XvSetOrderStatusReq, O: XvSetOrderStatusResp },
    { name: "Orders", options: { "pr.v3.roles": { roles: ["ROLE_ADMIN"] } }, I: OrdersReq, O: OrdersResp },
    { name: "DeleteFile", options: { "pr.v3.roles": { roles: ["ROLE_ADMIN"] } }, I: DeleteFileReq, O: DeleteFileResp },
    { name: "AddMoney", options: { "pr.v3.roles": { roles: ["ROLE_ADMIN"] } }, I: AddMoneyReq, O: AddMoneyResp },
    { name: "OrderToAdm", options: { "pr.v3.roles": { roles: ["ROLE_ADMIN"] } }, I: OrderToAdmReq, O: OrderToAdmResp },
    { name: "UpdateOrder", options: { "pr.v3.roles": { roles: ["ROLE_ADMIN"] } }, I: UpdateOrderReq, O: UpdateOrderResp },
    { name: "OrderPayed", options: { "pr.v3.roles": { roles: ["ROLE_ADMIN"] } }, I: OrderPayedReq, O: OrderPayedResp },
    { name: "OrderAcceptPrice", options: { "pr.v3.roles": { roles: ["ROLE_ADMIN"] } }, I: OrderAcceptPriceReq, O: OrderAcceptPriceResp },
    { name: "XvOrdersHistory", options: { "pr.v3.roles": { roles: ["ROLE_ADMIN"] } }, I: XvOrdersHistoryReq, O: XvOrdersHistoryResp },
    { name: "XvOrder", options: { "pr.v3.roles": { roles: ["ROLE_ADMIN"] } }, I: XvOrderReq, O: XvOrderResp },
    { name: "XvUpdateOrder", options: { "pr.v3.roles": { roles: ["ROLE_ADMIN"] } }, I: XvUpdateOrderReq, O: XvUpdateOrderResp },
    { name: "XvDeleteFile", options: { "pr.v3.roles": { roles: ["ROLE_ADMIN"] } }, I: XvDeleteFileReq, O: XvDeleteFileResp },
    { name: "Users", options: { "pr.v3.roles": { roles: ["ROLE_ADMIN"] } }, I: UsersReq, O: UsersResp },
    { name: "XvAddFiles", options: { "pr.v3.roles": { roles: ["ROLE_ADMIN"] } }, I: XvAddFilesReq, O: XvAddFilesResp },
    { name: "OrderHistoryToAdmin", options: { "pr.v3.roles": { roles: ["ROLE_ADMIN"] } }, I: OrderHistoryToAdminReq, O: OrderHistoryToAdminResp },
    { name: "XvUserOrders", options: { "pr.v3.roles": { roles: ["ROLE_ADMIN"] } }, I: XvUserOrdersReq, O: XvUserOrdersResp },
    { name: "User", options: { "pr.v3.roles": { roles: ["ROLE_ADMIN"] } }, I: UserReq, O: UserResp },
    { name: "XvOrderPayNotify", options: { "pr.v3.roles": { roles: ["ROLE_ADMIN"] } }, I: XvOrderPayNotifyReq, O: XvOrderPayNotifyResp },
    { name: "Auth", options: { "pr.v3.roles": { roles: ["ROLE_ANY"] } }, I: AuthRequest, O: AuthResponse }
]);
